import TaxTreatmentFields from './TaxTreatmentFields';
//frontend/src/components/OfferForm
import React, { useState, useEffect, useCallback, useRef  } from "react";
/* global axios */
import api from '../services/apiService';
import { useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { isHoliday } from './holidays'; // Pfad anpassen, z. B. './holidays' oder '../holidays'
import { Helmet } from 'react-helmet';  // Import von React Helmet
import { v4 as uuidv4 } from 'uuid';





// Funktion zur Formatierung des Datums in "TT.MM.JJJJ"
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

// Funktion zur Formatierung von Datum+Uhrzeit in "TT.MM.JJJJ HH:MM"
const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day     = String(date.getDate()).padStart(2, '0');
  const month   = String(date.getMonth() + 1).padStart(2, '0');
  const year    = date.getFullYear();
  const hours   = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

const EMPTY_CONTACT = {
  contactFirstName: '',
  contactLastName: '',
  contactPhone: '',
  contactMobile: '',
  contactEmail: '',
};

const hasContactMobile = (contact) => Boolean((contact?.contactMobile || '').trim());

const ContactDialog = ({
  open,
  title,
  roleLabel,
  description,
  customerName,
  contact,
  error,
  isSaving,
  onChange,
  onClose,
  onSave,
  saveLabel = 'Anlegen und auswählen',
  savingLabel = 'Wird gespeichert …',
  saveColor = '#28a745',
}) => {
  if (!open) return null;

  return (
    <div
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1100, padding: 16,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={{
          background: '#fff', padding: 20, borderRadius: 8, width: '100%',
          maxWidth: 480, boxShadow: '0 8px 28px rgba(0, 0, 0, 0.25)',
        }}
      >
        <h3 style={{ marginTop: 0 }}>{title}</h3>
        <p style={{ marginTop: 0, color: '#555' }}>
          {description || `Der Kontakt wird als ${roleLabel} bei ${customerName || 'diesem Kunden'} gespeichert.`}
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <label>
            Vorname*
            <input
              type="text" name="contactFirstName" value={contact.contactFirstName}
              onChange={onChange} autoFocus
              style={{ width: '100%', boxSizing: 'border-box', marginTop: 4 }}
            />
          </label>
          <label>
            Nachname*
            <input
              type="text" name="contactLastName" value={contact.contactLastName}
              onChange={onChange}
              style={{ width: '100%', boxSizing: 'border-box', marginTop: 4 }}
            />
          </label>
          <label>
            Telefon
            <input
              type="tel" name="contactPhone" value={contact.contactPhone}
              onChange={onChange}
              style={{ width: '100%', boxSizing: 'border-box', marginTop: 4 }}
            />
          </label>
          <label>
            Mobil
            <input
              type="tel" name="contactMobile" value={contact.contactMobile}
              onChange={onChange}
              style={{ width: '100%', boxSizing: 'border-box', marginTop: 4 }}
            />
          </label>
          <label style={{ gridColumn: '1 / -1' }}>
            E-Mail
            <input
              type="email" name="contactEmail" value={contact.contactEmail}
              onChange={onChange}
              style={{ width: '100%', boxSizing: 'border-box', marginTop: 4 }}
            />
          </label>
        </div>

        {error && <div role="alert" style={{ color: '#b42318', marginTop: 12 }}>{error}</div>}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
          <button
            type="button" onClick={onClose} disabled={isSaving}
            style={{
              padding: '8px 12px', backgroundColor: '#6c757d', color: '#fff', border: 'none',
              borderRadius: 5, cursor: isSaving ? 'not-allowed' : 'pointer'
            }}
          >
            Abbrechen
          </button>
          <button
            type="button" onClick={onSave} disabled={isSaving}
            style={{
              padding: '8px 12px', backgroundColor: saveColor, color: '#fff', border: 'none',
              borderRadius: 5, cursor: isSaving ? 'wait' : 'pointer'
            }}
          >
            {isSaving ? savingLabel : saveLabel}
          </button>
        </div>
      </div>
    </div>
  );
};





const OfferForm = ({ mode, onSave }) => {
  const { offerId } = useParams();
  const navigate = useNavigate();
  



  const [offer, setOffer] = useState({
    customerId: "",
    contactId: "",
    lwOperatorId: "",  // Ansprechpartner vor Ort hinzufügen
    deliveryTime: "",
    operationLocation: "",
    notes: "",
    internalNotes: "",
    date: "",
    includeLaddersInEmail: false,
    allowEmailAcceptance: true,
    isReservation: false,// Checkbox für Reservierung im Kalender
    
  });

  const [offerNoteTextBlocks, setOfferNoteTextBlocks] = useState([]);
  const [selectedOfferNoteTextBlockId, setSelectedOfferNoteTextBlockId] = useState('');
  const [offerNoteTextBlocksLoading, setOfferNoteTextBlocksLoading] = useState(false);

// Temporäre Zustände für die Checkboxen
const [tempIncludeSaturday, setTempIncludeSaturday] = useState(false);
const [tempIncludeSunday, setTempIncludeSunday] = useState(false);
const [tempIncludeHolidays, setTempIncludeHolidays] = useState(false);

  // In OfferForm.js, ganz oben
const [selectedItemId, setSelectedItemId] = useState(null);
const [selectedQuantity, setSelectedQuantity] = useState(1);
const [offerItems, setOfferItems] = useState([]);  // State für Angebotspositionen
const [items, setItems] = useState([]);  // State für alle verfügbaren Artikel
const [editingRowId, setEditingRowId] = useState(null); // Verfolgt die aktuell bearbeitete Zeile
const [units, setUnits] = useState([]); // State für Einheiten , 
const [selectedUnitId, setSelectedUnitId] = useState(null); // Zustand für die zuletzt verwendete Einheit
const isEditing = editingRowId !== null;
const [tempRentalPeriodFrom, setTempRentalPeriodFrom] = useState("");
const [tempRentalPeriodTo, setTempRentalPeriodTo] = useState("");
const [tempRentalTimeFrom, setTempRentalTimeFrom] = useState("");
const [tempRentalTimeTo, setTempRentalTimeTo] = useState("");
const [originalOfferItems, setOriginalOfferItems] = useState([]);
const [calculatedOfferItems, setCalculatedOfferItems] = useState([]); // Berechnete Daten
const [holidays, setHolidays] = useState([]);
const [companySetup, setCompanySetup] = useState(null);

// --- OperationLocation Suggest (analog OrderForm) ---
const [opLocInput, setOpLocInput] = useState('');
const [opLocSuggest, setOpLocSuggest] = useState([]);
const [opLocOpen, setOpLocOpen] = useState(false);
const [opLocLoading, setOpLocLoading] = useState(false);
const [opLocIndex, setOpLocIndex] = useState(-1);
const opLocWrapRef = useRef(null);

const rememberOpLoc = useCallback(async (label) => {
  try {
    const trimmed = String(label || '').trim();
    if (!trimmed) return;
    await api.post('/operation-locations/remember', { label: trimmed });
  } catch (e) {
    console.warn('[rememberOpLoc] failed:', e?.response?.data || e?.message || e);
  }
}, []);

const fetchOpLocSuggest = useCallback(
  debounce(async (q) => {
    try {
      setOpLocLoading(true);
      const { data } = await api.get('/operation-locations/suggest', { params: { q, limit: 12 } });
      setOpLocSuggest(Array.isArray(data) ? data : []);
      setOpLocOpen(true);
    } catch (e) {
      console.error('operationLocation suggest failed', e);
      setOpLocSuggest([]);
    } finally {
      setOpLocLoading(false);
    }
  }, 250),
  []
);

useEffect(() => () => fetchOpLocSuggest.cancel?.(), [fetchOpLocSuggest]);

useEffect(() => {
  setOpLocInput(offer?.operationLocation || '');
}, [offer?.operationLocation]);

const onOpLocChange = (e) => {
  const v = e.target.value;
  setOpLocInput(v);
  setOffer(prev => ({ ...prev, operationLocation: v }));
  fetchOpLocSuggest(v.trim());
};

const onOpLocFocus = () => {
  fetchOpLocSuggest('');
};

const onOpLocBlur = async () => {
  const v = (opLocInput || '').trim();
  if (!v) return;
  await rememberOpLoc(v);
};

const selectOpLoc = async (label) => {
  setOffer(prev => ({ ...prev, operationLocation: label }));
  setOpLocInput(label);
  setOpLocOpen(false);
  setOpLocIndex(-1);
  await rememberOpLoc(label);
};

useEffect(() => {
  const onDocClick = (e) => {
    if (!opLocWrapRef.current) return;
    if (!opLocWrapRef.current.contains(e.target)) {
      setOpLocOpen(false);
      setOpLocIndex(-1);
    }
  };
  document.addEventListener('mousedown', onDocClick);
  return () => document.removeEventListener('mousedown', onDocClick);
}, []);

const onOpLocKeyDown = async (e) => {
  if (opLocOpen && opLocSuggest.length) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setOpLocIndex((i) => (i + 1) % opLocSuggest.length);
      return;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setOpLocIndex((i) => (i - 1 + opLocSuggest.length) % opLocSuggest.length);
      return;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const pick = opLocSuggest[opLocIndex] || opLocSuggest[0];
      if (pick) {
        await selectOpLoc(pick.label);
        return;
      }
    } else if (e.key === 'Escape') {
      setOpLocOpen(false);
      setOpLocIndex(-1);
      return;
    }
  }
  if (e.key === 'Enter') {
    const v = (opLocInput || '').trim();
    if (v) {
      setOffer(prev => ({ ...prev, operationLocation: v }));
      await rememberOpLoc(v);
      setOpLocOpen(false);
      setOpLocIndex(-1);
    }
  }
};
// --- /OperationLocation Suggest ---


 // Feiertage einmal beim Mount laden
 useEffect(() => {
   api.get('/holidays')
     .then(res => setHolidays(res.data))
     .catch(console.error);
 }, []);

useEffect(() => {
  if (mode !== 'edit') return undefined;

  let isMounted = true;
  setOfferNoteTextBlocksLoading(true);

  api.get('/text-blocks', {
    params: { usageArea: 'orderNotes', activeOnly: true },
  })
    .then((response) => {
      if (isMounted) {
        setOfferNoteTextBlocks(Array.isArray(response.data) ? response.data : []);
      }
    })
    .catch((error) => {
      console.error('Fehler beim Laden der Textbausteine für Angebotsnotizen:', error);
      if (isMounted) setOfferNoteTextBlocks([]);
    })
    .finally(() => {
      if (isMounted) setOfferNoteTextBlocksLoading(false);
    });

  return () => {
    isMounted = false;
  };
}, [mode]);


// einmalig laden (es gibt i. d. R. genau 1 CompanySetup)
useEffect(() => {
  (async () => {
    try {
      const res = await api.get('/companysetups');
      // nimm das erste Setup (oder das mit passender ID, falls ihr mehrere habt)
      setCompanySetup(Array.isArray(res.data) ? res.data[0] : res.data);
    } catch (e) {
      console.error('CompanySetup konnte nicht geladen werden:', e);
    }
  })();
}, []);

// Sicheres Filter nur auf dem Label — verhindert .replace() auf non-Strings
const safeFilterOption = (option, inputValue) => {
  const label = (option?.label ?? '').toString();
  const q = (inputValue ?? '').toString();
  return label.toLowerCase().includes(q.toLowerCase());
};

const formatItemOptionLabel = (item) => {
  const description = String(item?.description || '').trim();
  return `${item.name}${description ? ` - ${description}` : ''} (${item.itemType})`;
};

// Speichert nur eine einzelne Zeile
const saveEditedRow = async (rowId) => {
  try {
    // 1) Finde den Eintrag anhand seiner echten DB-ID
    const item = offerItems.find(i => i.id === rowId);
    if (!item) return;

    // Prüfen, ob es sich um einen Mietartikel handelt
    const isRental = item.item?.itemType === "rental";

    // Nur beim Miet-Typ muss rentalPeriodFrom gesetzt sein
    if (isRental && !item.rentalPeriodFrom) {
      return alert("Bitte das Datum ‚Von‘ ausfüllen, bevor Du speicherst.");
    }

    // 2) Baue Payload aus diesem einzelnen Eintrag
    const payload = {
      quantity:           item.quantity,
      unitId:             item.unitId,
      rentalPeriodFrom:   item.rentalPeriodFrom,
      // rentalPeriodTo wird serverseitig neu berechnet, muss nicht gesendet
      rentalTimeFrom:     item.rentalTimeFrom,
      rentalTimeTo:       item.rentalTimeTo,
      includeSaturday:    item.includeSaturday,
      includeSunday:      item.includeSunday,
      includeHolidays:    item.includeHolidays,
      pricePerUnit:       item.pricePerUnit,
      manualPriceActive:  item.manualPriceActive,
      description: item.description,
    };

    // 3) PUT-Request mit der echten DB-id
    const { data: updated } = await api.put(
      `/offers/${offer.id}/offeritems/${rowId}`,
      payload
    );

     // 4) NEU: updatedBy auf null setzen
    await api.post(`/offers/${offer.id}/reset-updatedby`);

    // 5) State: Ersetze nur genau dieses eine Objekt durch die vollständige Server-Antwort
    setOfferItems(prev =>
  prev
    .map(i => i.id === updated.id
      ? {
          ...updated,
          designPosition: (updated.designPosition === null || updated.designPosition === undefined)
            ? updated.position
            : updated.designPosition
        }
      : i
    )
    .sort((a, b) => (a.designPosition ?? a.position) - (b.designPosition ?? b.position))
);


    // 6) Bearbeitungsmodus beenden
    setEditingRowId(null);

  } catch (error) {
    console.error(`Fehler beim Speichern der Position ${rowId}:`, error);
    alert(`Fehler: Die Änderung der Position ${rowId} konnte nicht gespeichert werden.`);
  }
};



// Hilfsfunktion zum Parsen von Zeitstrings "HH:MM" in Millisekunden seit Mitternacht
const parseTime = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return (hours * 60 + minutes) * 60 * 1000; // Millisekunden
};

/**
  * Prüft synchron anhand des geladenen holidays-States,
  * ob date ein Feiertag ist.
  */
 const isHolidayDate = useCallback((date) => {
  const m = date.getMonth(); // 0-11
  const d = date.getDate();  // 1-31
  return holidays.some(h =>
    Number(h.month) === m &&
    Number(h.day) === d
  );
}, [holidays]);



const updateRentalPeriodTo = useCallback((sourceItems) => {
  const baseItems = Array.isArray(sourceItems) ? sourceItems : offerItems;
  // Filtern Sie alle offerItems vom Typ "rental"
  const rentalItems = baseItems.filter(item => {
    const correspondingItem = items.find(i => i.id === item.itemId);
    return correspondingItem && correspondingItem.itemType === "rental";
  });

  let updated = false; // Flag zur Überprüfung, ob eine Aktualisierung notwendig ist

  // Erstellen Sie eine neue Version von offerItems mit aktualisierten rentalPeriodTo
  const newOfferItems = baseItems.map(item => {
    if (rentalItems.some(rentalItem => rentalItem.id === item.id)) {
      if (item.rentalPeriodFrom && item.quantity) {
        const startDate = new Date(item.rentalPeriodFrom);
        let rentalDays = item.quantity; // Anzahl der gewünschten Tage oder Stunden
        let isTimeBased = false;

        // Überprüfen, ob die Einheit zeitbasiert ist (angenommen, unitId === 27 bedeutet Stunden)
        if (item.unit && item.unit.id === 27) {
          isTimeBased = true;
          // Prüfen, ob beide Zeitfelder ausgefüllt sind und die Einheit auf Zeit steht
          if (item.rentalTimeFrom && item.rentalTimeTo) {
            const timeFrom = parseTime(item.rentalTimeFrom);
            const timeTo = parseTime(item.rentalTimeTo);

            // Berechnung der Stunden im Zeitfenster
            const hoursPerDay = (timeTo - timeFrom) / (1000 * 60 * 60);
            if (hoursPerDay > 0) {
              rentalDays = Math.ceil(item.quantity / hoursPerDay);
            } else {
              // Falls timeTo kleiner oder gleich timeFrom ist, Standard von 24 Stunden verwenden
              rentalDays = Math.ceil(item.quantity / 24);
            }
          } else {
            rentalDays = Math.ceil(item.quantity / 24);
          }
        }

        // === NEU: Korrekte Miettage-Zählung wie im Backend ===
        // 1. Alle include-Werte in echte Booleans
        const includeSundayBool   = item.includeSunday === true || item.includeSunday === "true";
        const includeSaturdayBool = item.includeSaturday === true || item.includeSaturday === "true";
        const includeHolidaysBool = item.includeHolidays === true || item.includeHolidays === "true";

        // 2. Ersten erlaubten Miettag suchen, dann weiterzählen
        let cursor = new Date(startDate);

        // Suche den ersten erlaubten Tag
        while (true) {
          const dow = cursor.getDay(); // 0=So, 6=Sa
          const isHoliday = isHolidayDate(cursor);
          const allowed =
            (dow >= 1 && dow <= 5 && (!isHoliday || includeHolidaysBool)) ||
            (dow === 6 && includeSaturdayBool) ||
            (dow === 0 && includeSundayBool) ||
            (includeHolidaysBool && isHoliday);
          if (allowed) break;
          cursor.setDate(cursor.getDate() + 1);
        }

        // Jetzt noch (rentalDays-1) erlaubte Miettage zählen:
        let daysLeft = rentalDays - 1;
        while (daysLeft > 0) {
          cursor.setDate(cursor.getDate() + 1);
          const dow = cursor.getDay();
          const isHoliday = isHolidayDate(cursor);
          const allowed =
            (dow >= 1 && dow <= 5 && (!isHoliday || includeHolidaysBool)) ||
            (dow === 6 && includeSaturdayBool) ||
            (dow === 0 && includeSundayBool) ||
            (includeHolidaysBool && isHoliday);
          if (allowed) daysLeft--;
        }

        // cursor ist jetzt der letzte Miettag
        const rentalPeriodToDate = new Date(cursor);
        const formattedRentalPeriodTo = rentalPeriodToDate.toISOString().split('T')[0];

        // Überprüfen, ob eine Aktualisierung notwendig ist
        if (item.rentalPeriodTo !== formattedRentalPeriodTo) {
          updated = true;
          return { ...item, rentalPeriodTo: formattedRentalPeriodTo };
        }
      }
    }
    return item;
  });

  // Aktualisieren Sie den State nur, wenn eine Änderung vorgenommen wurde
  if (updated) {
    setOfferItems(newOfferItems);
  }
}, [offerItems, items, isHolidayDate]);


 



// Funktion zur Aktualisierung der Einheit im Backend
const updateOfferItemUnit = async (offerId, offerItemId, newUnitId, newQuantity) => {
  try {
    const payload = {
      id: offerItemId,
      unitId: newUnitId,
      quantity: newQuantity,  // Hier fügst du die Menge hinzu
    };

    const response = await api.put(
      `/offers/${offerId}/offeritems/${offerItemId}`, 
      payload
    );
    console.log('Einheit und Menge erfolgreich aktualisiert:', response.data);
  } catch (error) {
    console.error('Fehler beim Aktualisieren der Einheit:', error);
  }
};

const getMatchingPricing = (item, quantity, newUnitId) => {
  // Überprüfen, ob die Preisstaffelung existiert für die neue Einheit (newUnitId)
  const pricing = item.item.machineType?.typePricings.find((pricing) => {
    return quantity >= pricing.minQuantity && quantity <= pricing.maxQuantity && pricing.unitId === newUnitId;
  });

  if (pricing) {
    const pricePerUnit = pricing.pricePerUnit;
    const total = pricePerUnit * quantity;
    return { pricePerUnit, total };
  } else {
    // Wenn keine Preisstaffelung gefunden wird, setze Standardwerte
    return { pricePerUnit: 0, total: 0 };
  }
};



// Angebotspositionen entfernen
const removeOfferItem = async (offerItemId) => {
  console.log("Remove-Handler aufgerufen mit ID:", offerItemId);
  try {
    console.log(`Entferne Angebotsposition mit ID: ${offerItemId} für Angebot ID: ${offer.id}`);

    // API-Aufruf, um die Angebotsposition zu entfernen
    const response = await api.delete(`/offers/${offer.id}/offeritems/${offerItemId}`);
    console.log('API-Antwort beim Entfernen:', response.data, 'Status:', response.status);

    // Überprüfen, ob die Antwort erfolgreich war
    if (response.status === 200 || response.status === 204) {
      // Entferne das OfferItem aus dem lokalen State
      setOfferItems((prevItems) => {
        const updatedItems = prevItems.filter((item) => item.id !== offerItemId);
        console.log("Aktualisierte Angebotspositionen nach dem Entfernen:", updatedItems); // Log hinzufügen
        return updatedItems;
      });

      console.log(`Angebotsposition mit ID ${offerItemId} erfolgreich entfernt.`);
    } else {
      console.error(`Fehler beim Entfernen der Angebotsposition: Unerwarteter Status ${response.status}`);
    }
  } catch (error) {
    // Detaillierte Fehlerbehandlung und Logausgabe
    console.error('Fehler beim Entfernen der Angebotsposition:', error.message || error);

    // Benutzer über den Fehler informieren
    alert('Fehler: Die Angebotsposition konnte nicht entfernt werden. Bitte versuchen Sie es später erneut.');
  }
};


// Funktion zum Abrufen der Angebotspositionen
const fetchOfferItems = async () => {
  try {
    const response = await api.get(`/offers/${offerId}/offeritems`);
    if (!Array.isArray(response.data)) return;

    const itemsFromServer = response.data.map(item => ({
      ...item,
      designPosition:
        (item.designPosition === null || item.designPosition === undefined)
          ? item.position
          : item.designPosition,
      tempId: item.id,
      manualPriceActive: !!item.manualPriceActive,
    }));

    setOfferItems(
  itemsFromServer.sort(
    (a, b) => Number(a.designPosition ?? a.position ?? 0) - Number(b.designPosition ?? b.position ?? 0)
  )
);
  } catch (error) {
    console.error('Fehler beim Abrufen der Angebotspositionen:', error);
  }
};




// 1. Angebotspositionen abrufen, wenn offer.id sich ändert
useEffect(() => {
  if (offer.id) {
    fetchOfferItems(); // Funktion wird jetzt global aufgerufen
    fetchUnits(); // Einheiten abrufen (falls benötigt)
  }
}, [offer.id]);

// 2. rentalPeriodTo berechnen, wenn offerItems sich ändern
useEffect(() => {
  if (offerItems.length > 0) {
    updateRentalPeriodTo();
  }
}, [offerItems, updateRentalPeriodTo]);

// 3. Artikel laden (nur beim ersten Laden der Seite)
useEffect(() => {
  const fetchItems = async () => {
    try {
      const response = await api.get('/items');
      // Nur Artikel mit deactivated = false
      const activeItems = response.data.filter(item => item.deactivated === false);
      setItems(activeItems);
    } catch (error) {
      console.error('Fehler beim Laden der Artikel:', error);
    }
  };
  fetchItems();
}, []);

// Dieser useEffect wird jedes Mal ausgeführt,
  // wenn sich 'offerItems' ändert, und setzt den globalen Zustand.
  useEffect(() => {
    if (offerItems.length > 0) {
      // Beispiel: Setze den globalen Zustand, wenn mind. ein Item 'true' hat.
      setTempIncludeSaturday(offerItems.some(item => item.includeSaturday));
      setTempIncludeSunday(offerItems.some(item => item.includeSunday));
      setTempIncludeHolidays(offerItems.some(item => item.includeHolidays));
    }
  }, [offerItems]);

// Angebotsposition hinzufügen
const addOfferItem = async () => {
  try {
    if (!selectedItemId || selectedQuantity <= 0) {
      alert('Bitte wählen Sie einen Artikel aus und geben Sie eine gültige Menge an.');
      console.warn("Ungültige Eingabedaten: ", { selectedItemId, selectedQuantity });
      return;
    }

    const item = items.find((i) => i.id === selectedItemId);

    // Einheit-Resolving überlässt das Backend:
    const finalUnitId = null;

    const payload = {
      offerId: offer.id,            // ID des aktuellen Angebots
      itemId: selectedItemId,       // Artikel-ID
      quantity: selectedQuantity,   // Menge
      unitId: finalUnitId,          // null → Backend wählt passende Einheit
      rentalPeriodFrom: null,    // <-- nun ok für nullable TIMESTAMP
      rentalPeriodTo:   null,    // <-- ditto
      rentalTimeFrom:   null,
      rentalTimeTo:     null,
      includeSaturday: tempIncludeSaturday,
      includeSunday:  tempIncludeSunday,
      includeHolidays: tempIncludeHolidays,
    };

    console.log("Daten für den POST-Request:", payload);

   // 1) Haupt- und Linked-Items anlegen
    const { mainOfferItem, linkedOfferItems } = await api
      .post(`/offers/${offerId}/offeritems`, payload)
      .then(res => res.data);

    // 2) Haupt-Item komplett mit Includes nachladen
    const fullMain = await api
      .get(`/offers/${offerId}/offeritems/${mainOfferItem.id}`)
      .then(res => res.data);

    // 3) Verknüpfte Items komplett mit Includes nachladen
    const fullLinked = await Promise.all(
      linkedOfferItems.map(li =>
        api
          .get(`/offers/${offerId}/offeritems/${li.id}`)
          .then(res => res.data)
      )
    );

    // nach fullMain und fullLinked geholt:
const mainWithTemp = {
  ...fullMain,
  tempId: uuidv4(),         // neu
  manualPriceActive: false,
};
const linkedWithTemp = fullLinked.map(item => ({
  ...item,
  tempId: uuidv4(),         // neu
  manualPriceActive: false,
}));

   // 4) Haupt- und Linked-Items ans Ende hängen und nach position sortieren
  // Haupt- und Linked-Items ans Ende hängen und nach position sortieren
setOfferItems(prev => {
  // Sicher numerisch den aktuellen Max-Wert bestimmen
  const max = prev.reduce(
    (m, i) => Math.max(m, Number(i.designPosition ?? i.position ?? 0)),
    0
  );

  // NÄCHSTE freie Positionsnummer
  let next = max + 1;

  // WICHTIG: Eingehende designPosition/position IGNORIEREN → wir vergeben strikt neue laufende Nummern
  const normalized = [
    ...prev,
    { ...fullMain, designPosition: next++ },
    ...fullLinked.map(li => ({ ...li, designPosition: next++ }))
  ];

  // Reihenfolge direkt im Backend persistieren
  saveOfferItemDesignPositions(normalized);

  // Sicher numerisch sortieren
  return normalized.sort(
    (a, b) => Number(a.designPosition ?? a.position ?? 0) - Number(b.designPosition ?? b.position ?? 0)
  );
});



    // 6) Eingaben zurücksetzen
    setSelectedItemId(null);
    setSelectedQuantity(1);

  } catch (error) {
    console.error('Fehler beim Hinzufügen der Angebotsposition:', error);
  }
};



const getUnitId = (item) => {
  // Überprüfe, ob eine Einheit im TypePricing existiert
  const typePricingUnitId = item?.machineType?.typePricings?.[0]?.unitId;

  // Falls keine Einheit im TypePricing gefunden, überprüfe das TransportPricing
  const transportUnitId = item?.transportPricings?.[0]?.unitId;

  // Setze die Einheit für Versicherungsartikel auf "Prozent" (id: 33)
  if (item?.itemType === 'insurance') {
    return 33;
  }

  // Wenn keine Einheit gefunden wurde, gebe null zurück
  return typePricingUnitId || transportUnitId || null;
};


const handleCheckboxChange = async (offerItemId, field, value) => {
  try {
    // Aktualisieren des offerItems-Zustands lokal
    const updatedOfferItems = offerItems.map(item => {
      if (item.id === offerItemId) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setOfferItems(updatedOfferItems);
    console.log(`Checkbox '${field}' für Angebotsposition ${offerItemId} auf ${value} gesetzt.`);

    // Berechnung der rentalPeriodTo nach der Änderung
    updateRentalPeriodTo(updatedOfferItems);

    // Speichern der Änderung im Backend
    const updatedItem = updatedOfferItems.find(item => item.id === offerItemId);
    if (updatedItem) {
      await api.put(`/offers/${offerId}/offeritems/${offerItemId}`, updatedItem);
      console.log(`Angebotsposition ${offerItemId} erfolgreich aktualisiert.`);
    }
  } catch (error) {
    console.error(`Fehler beim Aktualisieren der Angebotsposition ${offerItemId}:`, error);
    alert(`Fehler: Die Änderung an Angebotsposition ${offerItemId} konnte nicht gespeichert werden.`);
  }
};


// Funktion zur globalen Aktualisierung der Checkbox-Zustände in allen offerItems
const handleGlobalCheckboxChange = async (field, value) => {
  try {
    // Aktualisiere zusätzlich den globalen Checkbox-Zustand
    if (field === 'includeSaturday') setTempIncludeSaturday(value);
    if (field === 'includeSunday') setTempIncludeSunday(value);
    if (field === 'includeHolidays') setTempIncludeHolidays(value);

    const updatedItems = offerItems.map(item => ({
      ...item,
      [field]: value,
    }));

    console.log("Vor setOfferItems (aktualisiert):", updatedItems);
    setOfferItems(updatedItems);

    // Backend-Anfrage
    const updatePromises = updatedItems.map(item =>
      api.put(`/offers/${offerId}/offeritems/${item.id}`, item)
    );
    await Promise.all(updatePromises);

    console.log("Nach Backend-Update erfolgreich!");
  } catch (error) {
    console.error(`Fehler beim Aktualisieren von ${field}:`, error);
  }
};
















// Einheiten abrufen und im Zustand speichern
const fetchUnits = async () => {
  try {
    const response = await api.get('/units'); // Beispiel-Endpoint zum Abrufen der Einheiten
    console.log("Geladene Einheiten:", response.data);
    setUnits(response.data); // Setze den Zustand für die Einheiten
  } catch (error) {
    console.error('Fehler beim Abrufen der Einheiten:', error);
  }
};







// Angebotsposition bearbeiten
const editOfferItem = (offerItemId) => {
  console.log("Edit-Handler aufgerufen mit ID:", offerItemId);
  
  // Setze die ID der Zeile, die bearbeitet werden soll
  setEditingRowId(offerItemId);

  // Finde die Angebotsposition
  const offerItemToEdit = offerItems.find((item) => item.id === offerItemId);
  if (offerItemToEdit) {
    // Setze die Daten für die Bearbeitung
    setSelectedItemId(offerItemToEdit.itemId);
    setSelectedQuantity(offerItemToEdit.quantity);

    // Achte darauf, dass auch die Einheit korrekt beibehalten wird
    setSelectedUnitId(offerItemToEdit.unitId);  // Einheit bleibt erhalten

     // Temporäre Zustände für die Mietzeitfelder des offerItems setzen
     setTempRentalPeriodFrom(offerItemToEdit.rentalPeriodFrom || "");
     setTempRentalPeriodTo(offerItemToEdit.rentalPeriodTo || "");
     setTempRentalTimeFrom(offerItemToEdit.rentalTimeFrom || "");
     setTempRentalTimeTo(offerItemToEdit.rentalTimeTo || "");

     // Initialisiere die temporären Checkboxwerte mit den offerItem-Werten
     setTempIncludeSaturday(offerItemToEdit.includeSaturday);
     setTempIncludeSunday(offerItemToEdit.includeSunday);
     setTempIncludeHolidays(offerItemToEdit.includeHolidays);
  } else {
    // Fehlerbehandlung
    console.error("Angebotsposition nicht gefunden:", offerItemId);
    console.log("Aktuelle Angebotspositionen:", offerItems); // Logge den Zustand von offerItems
  }
};

/// Angebotsposition Einheit im Backend aktualisieren
const saveOfferItemUnit = async (offerId, offerItems) => {
  try {
    // Überprüfen, ob offerId vorhanden ist
    if (!offerId) {
      throw new Error("OfferId ist nicht definiert");
    }

    // Überprüfen, ob offerItems ein gültiges Array ist
    if (!Array.isArray(offerItems) || offerItems.length === 0) {
      throw new Error("OfferItems ist nicht definiert oder kein gültiges Array");
    }

    // Optional: Jede Angebotsposition überprüfen, ob sie eine id und unitId hat
    offerItems.forEach((item, index) => {
      if (!item.id) {
        throw new Error(`Fehlende id für Angebotsposition an Index ${index}: ${JSON.stringify(item)}`);
      }

      // Überprüfen, ob die Einheit korrekt gesetzt ist
      if (item.unitId === undefined || item.unitId === null) {
        throw new Error(`Fehlende unitId für Angebotsposition an Index ${index}: ${JSON.stringify(item)}`);
      }

      // Spezielle Behandlung für Versicherungsartikel (unitId muss 33 sein)
      if (item.itemType === 'insurance' && item.unitId !== 33) {
        item.unitId = 33;  // Setze die unitId auf 33 für Versicherungsartikel
      }
    });

    // Backend-URL korrekt formatieren und die Angebotspositionen als Array senden
    const response = await api.put(`/offers/${offerId}/offeritems`, offerItems);
    console.log(`Angebotspositionen erfolgreich gespeichert:`, response.data);

  } catch (error) {
    console.error(`Fehler beim Speichern der Angebotspositionen:`, error.message);
  }
};














const saveChanges = async () => {
  try {
    console.log('Speichere Daten der Angebotspositionen:', offerItems);

    const updatePromises = offerItems.map(async (item) => {
      const payload = {
        id: item.id,
        itemId: item.itemId,
        quantity: item.quantity,
        unitId: item.unitId,
        rentalPeriodFrom: item.rentalPeriodFrom,
        rentalPeriodTo: item.rentalPeriodTo,
        rentalTimeFrom: item.rentalTimeFrom,
        rentalTimeTo: item.rentalTimeTo,
        includeSaturday: item.includeSaturday,
        includeSunday: item.includeSunday,
        includeHolidays: item.includeHolidays,
        pricePerUnit: item.pricePerUnit,
        manualPriceActive: item.manualPriceActive,
        description: item.description,
      };

      try {
        const response = await api.put(
          `/offers/${offer.id}/offeritems/${item.id}`,
          payload
        );
        if (response.status === 200 || response.status === 204) {
          console.log(`Position ${item.id} erfolgreich gespeichert.`);
        }
      } catch (err) {
        console.error(`Fehler beim Speichern der Position ${item.id}:`, err);
        throw new Error(`Fehler beim Speichern der Position ${item.id}`);
      }
    });

    await Promise.all(updatePromises);

    console.log('Alle Positionen erfolgreich gespeichert.');

    // Abrufen der aktuellen Positionen
    const updatedResponse = await api.get(`/offers/${offer.id}/offeritems`);
    console.log('Backend-Daten vor Verarbeitung:', updatedResponse.data);

    if (Array.isArray(updatedResponse.data)) {
      // Mergen: Für jedes vom Backend geladene OfferItem prüfen, ob im lokalen State bereits ein Wert für manualPriceActive gesetzt ist
      const mergedItems = updatedResponse.data.map(backendItem => {
        const localItem = offerItems.find(item => item.id === backendItem.id);
        return {
          ...backendItem,
          manualPriceActive: localItem && typeof localItem.manualPriceActive !== 'undefined'
            ? localItem.manualPriceActive
            : backendItem.manualPriceActive
        };
      });
      setOfferItems(mergedItems);
      console.log('OfferItems nach Backend-Synchronisation (mit Merge):', mergedItems);
    }

    alert('Alle Änderungen wurden erfolgreich gespeichert!');
    setEditingRowId(null);
  } catch (error) {
    console.error('Fehler beim Speichern der Änderungen:', error);
    alert('Fehler: Änderungen konnten nicht gespeichert werden.');
  }
};






 // Abbrechen der Bearbeitung
 const handleEditClick = (rowId) => {
  if (!offerItems || offerItems.length === 0) {
    console.warn("Keine OfferItems verfügbar, um den Bearbeitungsmodus zu starten.");
    return;
  }

  console.log("Speichern der ursprünglichen OfferItems vor Bearbeitung:", offerItems);

  // Speichere die ursprünglichen OfferItems als Kopie
  setOriginalOfferItems([...offerItems]);

  // Finde das OfferItem, das bearbeitet wird, und setze die temporären Zustände
  const itemToEdit = offerItems.find(item => item.id === rowId);
  if (itemToEdit) {
    console.log("Bearbeitung starten für:", itemToEdit);
    setSelectedItemId(itemToEdit.itemId);
    setSelectedQuantity(itemToEdit.quantity || 1);
    setTempIncludeSaturday(itemToEdit.includeSaturday === true);
    setTempIncludeSunday(itemToEdit.includeSunday === true);
    setTempIncludeHolidays(itemToEdit.includeHolidays === true);
  } else {
    console.warn(`Kein OfferItem mit der ID ${rowId} gefunden.`);
  }

  setEditingRowId(rowId);
};

useEffect(() => {
  if (editingRowId) {
    console.log("Bearbeitungsmodus aktiviert. Speichere aktuelle OfferItems:", offerItems);
    setOriginalOfferItems([...offerItems]); // Kopie der aktuellen OfferItems speichern
  }
}, [editingRowId, offerItems]);





const handleCancelEdit = () => {
  console.log("Abbrechen gedrückt. Original OfferItems:", originalOfferItems);

  if (!originalOfferItems || originalOfferItems.length === 0) {
    console.warn("Keine Originaldaten zum Zurücksetzen gefunden.");
    return;
  }

  // Setze offerItems auf die ursprünglichen Werte zurück
  setOfferItems([...originalOfferItems]);
  console.log("OfferItems nach Abbrechen zurückgesetzt auf:", originalOfferItems);

  // Beende den Bearbeitungsmodus
  setEditingRowId(null);
};







const handleSaveEditedOfferItem = async () => {
  try {
    // Aktualisieren der offerItems mit den temporären Zuständen
    const updatedOfferItems = offerItems.map(item => {
      if (item.id === editingRowId) {
        return {
          ...item,
          includeSaturday: tempIncludeSaturday,
          includeSunday: tempIncludeSunday,
          includeHolidays: tempIncludeHolidays,
        };
      }
      return item;
    });

    // Führen Sie die Berechnung durch
    updateRentalPeriodTo(updatedOfferItems);

    // Speichern Sie alle offerItems im Backend
    const updatePromises = updatedOfferItems.map(item =>
      api.put(`/offers/${offerId}/offeritems/${item.id}`, item)
    );
    await Promise.all(updatePromises);

    await api.post(`/offers/${offerId}/reset-updatedby`);

    // Aktualisieren Sie den Frontend-Zustand nach erfolgreichem Speichern
    setOfferItems(updatedOfferItems);

    // Beenden Sie den Bearbeitungsmodus
    setEditingRowId(null);

    alert('Alle Änderungen wurden erfolgreich gespeichert!');
  } catch (error) {
    console.error('Fehler beim Speichern der bearbeiteten Angebotsposition:', error);
    alert('Fehler: Die bearbeiteten Änderungen konnten nicht gespeichert werden.');
  }
};





const calculatePrice = (itemObj, quantity) => {
  let pricePerUnit = 0;
  let total = 0;

  if (itemObj.item?.machineType?.typePricings) {
    // Beispielhafte Preisstaffelungslogik
    const pricing = itemObj.item.machineType.typePricings.find(
      (p) => quantity >= p.minQuantity && quantity <= p.maxQuantity
    );
    if (pricing) {
      pricePerUnit = parseFloat(pricing.pricePerUnit);
      total = parseFloat((pricePerUnit * quantity).toFixed(2));
    }
  } else if (itemObj.item?.transportPricings?.[0]?.pricePerUnit) {
    pricePerUnit = parseFloat(itemObj.item.transportPricings[0].pricePerUnit);
    total = parseFloat((pricePerUnit * quantity).toFixed(2));
  }

  return { pricePerUnit, total };
};



const fetchFilteredItems = debounce(async (searchTerm) => {
  try {
    const response = await api.get(`/items?search=${searchTerm}`);
    // Auch hier nur aktive Artikel anzeigen
    const activeItems = response.data.filter(item => item.deactivated === false);
    setItems(activeItems);
  } catch (error) {
    console.error('Fehler beim Filtern der Artikel:', error);
  }
}, 300); // 300ms Verzögerung


const handleItemSearchChange = (inputValue) => {
  if (inputValue.trim() === '') {
    setItems([]); // Leere Liste, wenn keine Eingabe
    return;
  }

  fetchFilteredItems(inputValue); // Filtere Artikel basierend auf dem Suchbegriff
};

// Optionen für `react-select` transformieren
// nur die gewünschten itemTypes anzeigen
const allowedTypes = ['rental', 'sale', 'service', 'sparePart', 'transport']; 
const filteredItems = items.filter(item => allowedTypes.includes(item.itemType));

const itemOptions = filteredItems.map(item => ({
  value: item.id,
  label: formatItemOptionLabel(item)
}));










  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [lwOperatorContacts, setLWOperatorContacts] = useState([]); // State für Ansprechpartner vor Ort (LW-Bediener)
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedLWOperator, setSelectedLWOperator] = useState(null); // State für den ausgewählten Ansprechpartner vor Ort
  const [showNewLWOperatorDialog, setShowNewLWOperatorDialog] = useState(false);
  const [newLWOperator, setNewLWOperator] = useState(EMPTY_CONTACT);
  const [newLWOperatorError, setNewLWOperatorError] = useState('');
  const [isSavingLWOperator, setIsSavingLWOperator] = useState(false);
  const [showNewBestellerDialog, setShowNewBestellerDialog] = useState(false);
  const [newBesteller, setNewBesteller] = useState(EMPTY_CONTACT);
  const [newBestellerError, setNewBestellerError] = useState('');
  const [isSavingBesteller, setIsSavingBesteller] = useState(false);
  const [contactToEdit, setContactToEdit] = useState(null);
  const [editContactError, setEditContactError] = useState('');
  const [isSavingEditedContact, setIsSavingEditedContact] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [contactsLoadedForCustomer, setContactsLoadedForCustomer] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Kunden laden (nur einmal beim initialen Rendern)
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        console.log("Kunden werden geladen...");
        const customersResponse = await api.get("/customers");
        const loadedCustomers = customersResponse.data;
        setCustomers(loadedCustomers);
        setFilteredCustomers(loadedCustomers); // Zu Beginn alle Kunden anzeigen
        console.log("Kunden geladen:", loadedCustomers);
      } catch (error) {
        console.error("Fehler beim Laden der Kunden:", error);
      }
    };

    fetchCustomers();
  }, []);

    // Funktion, um die Kontakte eines bestimmten Kunden zu laden
    const loadContactsForCustomer = useCallback(async (customerId, contactId = null) => {
      try {
        if (!customerId || customerId === contactsLoadedForCustomer) return;
  
        console.log(`Lade Kontakte für Kunde mit ID: ${customerId}`);
        const response = await api.get(
          `/contacts/customer/${customerId}?contactFunction=Besteller`
        );
        setCustomerContacts(response.data);
        setContactsLoadedForCustomer(customerId);
        console.log("Kontakte geladen:", response.data);
  
        if (contactId) {
          const selectedContact = response.data.find(
            (contact) => contact.id.toString() === contactId.toString()
          );
          if (selectedContact) {
            setSelectedContact(selectedContact);
            setOffer((prev) => ({
              ...prev,
              allowEmailAcceptance: hasContactMobile(selectedContact)
                ? prev.allowEmailAcceptance !== false
                : false,
            }));
            console.log("Ausgewählter Besteller gesetzt:", selectedContact);
          }
        }
      } catch (error) {
        console.error("Fehler beim Laden der Besteller:", error);
      }
    }, [contactsLoadedForCustomer]);
  

  // Funktion, um die LW-Bediener-Kontakte eines bestimmten Kunden zu laden
  const loadLWOperatorContacts = useCallback(async (customerId, lwOperatorId = null) => {
    try {
      if (!customerId) return;

      console.log(`Lade LW-Bediener für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=LW-Bediener`
      );
      setLWOperatorContacts(response.data);
      console.log("LW-Bediener geladen:", response.data);

      if (lwOperatorId) {
        const selectedLWOperator = response.data.find(
          (contact) => contact.id.toString() === lwOperatorId.toString()
        );
        if (selectedLWOperator) {
          setSelectedLWOperator(selectedLWOperator);
          console.log("Ausgewählter Ansprechpartner vor Ort gesetzt:", selectedLWOperator);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der LW-Bediener:", error);
    }
  }, [setLWOperatorContacts]);



  // Angebot und zugehörige Daten laden, falls im Bearbeitungsmodus
  useEffect(() => {
    if (mode === "edit" && offerId && customers.length > 0 && !initialDataLoaded) {
      const fetchOfferData = async () => {
        try {
          console.log("Angebot wird geladen...");
          const offerResponse = await api.get(`/offers/${offerId}`);
          const fetchedOffer = offerResponse.data;

          // Überprüfe hier, ob die Daten die Angebotspositionen enthalten
        console.log("Geladenes Angebot:", fetchedOffer);
  
          setOffer({
            ...fetchedOffer,
            rentalPeriodFrom: normalizeDate(fetchedOffer.rentalPeriodFrom),
            rentalPeriodTo: normalizeDate(fetchedOffer.rentalPeriodTo),
            includeLaddersInEmail: !!fetchedOffer.includeLaddersInEmail,
            allowEmailAcceptance: fetchedOffer.allowEmailAcceptance !== false,
          });
  
          console.log("Angebot geladen:", fetchedOffer);
  
          if (fetchedOffer.customerId) {
            const selectedCustomer = customers.find(
              (customer) => customer.id.toString() === fetchedOffer.customerId.toString()
            );
            if (selectedCustomer) {
              setSelectedCustomer(selectedCustomer);
              console.log("Ausgewählter Kunde gesetzt:", selectedCustomer);
              // Kontakte und LW-Bediener nur einmal laden
              await loadContactsForCustomer(fetchedOffer.customerId, fetchedOffer.contactId);
              await loadLWOperatorContacts(fetchedOffer.customerId, fetchedOffer.lwOperatorId);
            }
          }
        } catch (error) {
          console.error("Fehler beim Laden des Angebots:", error);
        } finally {
          setInitialDataLoaded(true);
          setIsLoading(false);
        }
      };

      fetchOfferData();
    } else {
      setIsLoading(false);
    }
  }, [mode, offerId, customers, initialDataLoaded]);
  
  




  


 // Funktion, um das Datum zu normalisieren
const normalizeDate = (dateString) => dateString?.split("T")[0] || "";



  // Funktion zum Filtern der Kunden (debounced, um unnötige Anfragen zu vermeiden)
  const filterCustomers = debounce((inputValue) => {
    if (inputValue.trim() === "") {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter((customer) =>
        `${customer.company} ${customer.customerNumber} ${customer.firstName} ${customer.lastName} ${customer.street} ${customer.postalCode} ${customer.city}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, 300);

  // Handle search field changes
  const handleCustomerSearchChange = (inputValue) => {
    filterCustomers(inputValue);
  };

  // Kunde auswählen und alle zugehörigen Daten laden
  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setOffer((prev) => ({
        ...prev,
        customerId: "",
        contactId: "", // Kontakt ebenfalls zurücksetzen
      }));
      setSelectedCustomer(null);
      setCustomerContacts([]);
      setSelectedContact(null);
      setLWOperatorContacts([]);
      setSelectedLWOperator(null);
      return;
    }

    const selectedCustomerId = selectedOption.value;

    // Den neuen Kunden setzen und Besteller zurücksetzen
    setOffer((prev) => ({
      ...prev,
      customerId: selectedCustomerId,
      contactId: "", // Zurücksetzen des Bestellers, da der Kunde geändert wurde
      lwOperatorId: "", // Zurücksetzen des LW-Bedieners
    }));
    setSelectedContact(null);
    setSelectedLWOperator(null);

    // Den ausgewählten Kunden im Zustand speichern und anzeigen
    const selected = customers.find(
      (customer) => customer.id.toString() === selectedCustomerId.toString()
    );
    if (selected) {
      setSelectedCustomer(selected);
      console.log("Ausgewählter Kunde geändert:", selected);
      // Kontakte für den neuen Kunden laden
      loadContactsForCustomer(selectedCustomerId);
      loadLWOperatorContacts(selectedCustomerId);
    } else {
      setSelectedCustomer(null);
      console.log("Kunde konnte nicht gefunden werden");
    }
  };

    const handleOpenCustomerEdit = () => {
  if (!offer.customerId) return;
  navigate(`/customerform/${offer.customerId}`);
};


   // handleChange-Handler, um rentalPeriodFrom und rentalPeriodTo zu aktualisieren
   const handleChange = (e) => {
    const { name, value } = e.target;

    setOffer(prev => {
      const updatedOffer = {
        ...prev,
        [name]: value, // Aktualisiere das geänderte Feld
      };

      // Wenn rentalPeriodFrom geändert wurde, berechne rentalPeriodTo
      if (name === 'rentalPeriodFrom') {
        updateRentalPeriodTo(); // Berechne rentalPeriodTo basierend auf rentalPeriodFrom
      }

      return updatedOffer;
    });
  };
  
  

  const handleOfferNoteTextBlockChange = (event) => {
    const selectedId = event.target.value;
    setSelectedOfferNoteTextBlockId(selectedId);
    if (!selectedId) return;

    const selectedTextBlock = offerNoteTextBlocks.find(
      textBlock => String(textBlock.id) === String(selectedId)
    );
    if (!selectedTextBlock?.content) {
      setSelectedOfferNoteTextBlockId('');
      return;
    }

    setOffer(prev => {
      const existingNotes = String(prev.notes ?? '');
      const textToInsert = String(selectedTextBlock.content);
      let separator = '';

      if (existingNotes.length > 0) {
        separator = existingNotes.endsWith('\n\n')
          ? ''
          : existingNotes.endsWith('\n')
            ? '\n'
            : '\n\n';
      }

      return {
        ...prev,
        notes: `${existingNotes}${separator}${textToInsert}`,
      };
    });

    setSelectedOfferNoteTextBlockId('');
  };

  // Besteller ändern
  const handleContactChange = (e) => {
    const selectedContactId = e.target.value;
    const selected = customerContacts.find(
      (contact) => contact.id.toString() === selectedContactId.toString()
    );

    setOffer((prev) => ({
      ...prev,
      contactId: selectedContactId,
      allowEmailAcceptance: !!selected && hasContactMobile(selected),
    }));

    if (selected) {
      setSelectedContact(selected);
      console.log("Ausgewählter Besteller geändert:", selected);
    } else {
      setSelectedContact(null);
      console.log("Besteller konnte nicht gefunden werden");
    }
  };

// Ansprechpartner vor Ort ändern
const handleLWOperatorChange = (e) => {
  const selectedLWOperatorId = e.target.value;
  setOffer((prev) => ({
    ...prev,
    lwOperatorId: selectedLWOperatorId,
  }));

  const selected = lwOperatorContacts.find(
    (contact) => contact.id.toString() === selectedLWOperatorId.toString()
  );
  if (selected) {
    setSelectedLWOperator(selected);
    console.log("Ausgewählter Ansprechpartner vor Ort geändert:", selected);
  } else {
    setSelectedLWOperator(null);
    console.log("Ansprechpartner vor Ort konnte nicht gefunden werden");
  }
};

const openEditContactDialog = (contact) => {
  if (!contact) return;

  setContactToEdit({
    ...contact,
    contactFirstName: contact.contactFirstName || '',
    contactLastName: contact.contactLastName || '',
    contactPhone: contact.contactPhone || '',
    contactMobile: contact.contactMobile || '',
    contactEmail: contact.contactEmail || '',
  });
  setEditContactError('');
};

const closeEditContactDialog = () => {
  if (isSavingEditedContact) return;
  setContactToEdit(null);
  setEditContactError('');
};

const handleEditContactChange = (e) => {
  const { name, value } = e.target;
  setContactToEdit(prev => prev ? { ...prev, [name]: value } : prev);
  if (editContactError) setEditContactError('');
};

const sortContactsByName = (contacts) => [...contacts].sort((a, b) =>
  `${a.contactLastName || ''} ${a.contactFirstName || ''}`.localeCompare(
    `${b.contactLastName || ''} ${b.contactFirstName || ''}`,
    'de'
  )
);

const saveEditedContact = async () => {
  if (!contactToEdit?.id) return;

  const payload = {
    contactFirstName: contactToEdit.contactFirstName.trim(),
    contactLastName: contactToEdit.contactLastName.trim(),
    contactPhone: contactToEdit.contactPhone.trim(),
    contactMobile: contactToEdit.contactMobile.trim(),
    contactEmail: contactToEdit.contactEmail.trim(),
    contactFunction: contactToEdit.contactFunction,
    // Im Angebotsdialog nicht sichtbare Kontaktdaten beim PUT beibehalten.
    crmRole: contactToEdit.crmRole ?? null,
    isMainContact: Boolean(contactToEdit.isMainContact),
    notes: contactToEdit.notes ?? null,
    birthday: contactToEdit.birthday ?? null,
  };

  if (!payload.contactFirstName || !payload.contactLastName) {
    setEditContactError('Vorname und Nachname sind erforderlich.');
    return;
  }

  setIsSavingEditedContact(true);
  setEditContactError('');

  try {
    const response = await api.put(`/contacts/${contactToEdit.id}`, payload);
    const updatedContact = response.data;
    const isBesteller = String(updatedContact.contactFunction || '').toLowerCase() === 'besteller';

    if (isBesteller) {
      setCustomerContacts(prev => sortContactsByName(
        prev.map(contact => String(contact.id) === String(updatedContact.id) ? updatedContact : contact)
      ));
      setSelectedContact(updatedContact);
      setOffer(prev => ({
        ...prev,
        allowEmailAcceptance: hasContactMobile(updatedContact)
          ? prev.allowEmailAcceptance !== false
          : false,
      }));
    } else {
      setLWOperatorContacts(prev => sortContactsByName(
        prev.map(contact => String(contact.id) === String(updatedContact.id) ? updatedContact : contact)
      ));
      setSelectedLWOperator(updatedContact);
    }

    setContactToEdit(null);
  } catch (error) {
    console.error('Fehler beim Aktualisieren des Kontakts:', error);
    setEditContactError(
      error.response?.data?.details ||
      error.response?.data?.error ||
      'Der Kontakt konnte nicht aktualisiert werden.'
    );
  } finally {
    setIsSavingEditedContact(false);
  }
};

const findExistingContact = (contacts, payload) => {
  const normalize = value => String(value || '').trim().toLocaleLowerCase('de-DE');

  return contacts.find(contact => {
    const sameName =
      normalize(contact.contactFirstName) === normalize(payload.contactFirstName) &&
      normalize(contact.contactLastName) === normalize(payload.contactLastName);
    if (!sameName) return false;

    const enteredContactValues = [
      ['contactEmail', payload.contactEmail],
      ['contactPhone', payload.contactPhone],
      ['contactMobile', payload.contactMobile],
    ].filter(([, value]) => normalize(value));

    return enteredContactValues.length === 0 || enteredContactValues.some(
      ([field, value]) => normalize(contact[field]) === normalize(value)
    );
  });
};

const openNewLWOperatorDialog = () => {
  if (!offer.customerId) {
    alert('Bitte zuerst einen Kunden auswählen.');
    return;
  }
  setNewLWOperator(EMPTY_CONTACT);
  setNewLWOperatorError('');
  setShowNewLWOperatorDialog(true);
};

const closeNewLWOperatorDialog = () => {
  if (isSavingLWOperator) return;
  setShowNewLWOperatorDialog(false);
  setNewLWOperatorError('');
};

const handleNewLWOperatorChange = (e) => {
  const { name, value } = e.target;
  setNewLWOperator(prev => ({ ...prev, [name]: value }));
  if (newLWOperatorError) setNewLWOperatorError('');
};

const saveNewLWOperator = async () => {
  const payload = {
    contactFirstName: newLWOperator.contactFirstName.trim(),
    contactLastName: newLWOperator.contactLastName.trim(),
    contactPhone: newLWOperator.contactPhone.trim(),
    contactMobile: newLWOperator.contactMobile.trim(),
    contactEmail: newLWOperator.contactEmail.trim(),
    contactFunction: 'LW-Bediener',
  };

  if (!payload.contactFirstName || !payload.contactLastName) {
    setNewLWOperatorError('Vorname und Nachname sind erforderlich.');
    return;
  }

  const existingContact = findExistingContact(lwOperatorContacts, payload);
  if (existingContact) {
    setOffer(prev => ({ ...prev, lwOperatorId: existingContact.id }));
    setSelectedLWOperator(existingContact);
    setShowNewLWOperatorDialog(false);
    return;
  }

  setIsSavingLWOperator(true);
  setNewLWOperatorError('');
  try {
    const response = await api.post(`/contacts/${offer.customerId}`, payload);
    const createdContact = response.data;
    setLWOperatorContacts(prev => [...prev, createdContact].sort((a, b) =>
      `${a.contactLastName} ${a.contactFirstName}`.localeCompare(
        `${b.contactLastName} ${b.contactFirstName}`,
        'de'
      )
    ));
    setSelectedLWOperator(createdContact);
    setOffer(prev => ({ ...prev, lwOperatorId: createdContact.id }));
    setShowNewLWOperatorDialog(false);
    setNewLWOperator(EMPTY_CONTACT);
  } catch (error) {
    console.error('Fehler beim Anlegen des Vor-Ort-Ansprechpartners:', error);
    setNewLWOperatorError(
      error.response?.data?.details || error.response?.data?.error ||
      'Der Ansprechpartner konnte nicht angelegt werden.'
    );
  } finally {
    setIsSavingLWOperator(false);
  }
};

const openNewBestellerDialog = () => {
  if (!offer.customerId) {
    alert('Bitte zuerst einen Kunden auswählen.');
    return;
  }
  setNewBesteller(EMPTY_CONTACT);
  setNewBestellerError('');
  setShowNewBestellerDialog(true);
};

const closeNewBestellerDialog = () => {
  if (isSavingBesteller) return;
  setShowNewBestellerDialog(false);
  setNewBestellerError('');
};

const handleNewBestellerChange = (e) => {
  const { name, value } = e.target;
  setNewBesteller(prev => ({ ...prev, [name]: value }));
  if (newBestellerError) setNewBestellerError('');
};

const saveNewBesteller = async () => {
  const payload = {
    contactFirstName: newBesteller.contactFirstName.trim(),
    contactLastName: newBesteller.contactLastName.trim(),
    contactPhone: newBesteller.contactPhone.trim(),
    contactMobile: newBesteller.contactMobile.trim(),
    contactEmail: newBesteller.contactEmail.trim(),
    contactFunction: 'Besteller',
  };

  if (!payload.contactFirstName || !payload.contactLastName) {
    setNewBestellerError('Vorname und Nachname sind erforderlich.');
    return;
  }

  const existingContact = findExistingContact(customerContacts, payload);
  if (existingContact) {
    setOffer(prev => ({
      ...prev,
      contactId: existingContact.id,
      allowEmailAcceptance: hasContactMobile(existingContact),
    }));
    setSelectedContact(existingContact);
    setShowNewBestellerDialog(false);
    return;
  }

  setIsSavingBesteller(true);
  setNewBestellerError('');
  try {
    const response = await api.post(`/contacts/${offer.customerId}`, payload);
    const createdContact = response.data;
    setCustomerContacts(prev => [...prev, createdContact].sort((a, b) =>
      `${a.contactLastName} ${a.contactFirstName}`.localeCompare(
        `${b.contactLastName} ${b.contactFirstName}`,
        'de'
      )
    ));
    setSelectedContact(createdContact);
    setOffer(prev => ({
      ...prev,
      contactId: createdContact.id,
      allowEmailAcceptance: hasContactMobile(createdContact),
    }));
    setShowNewBestellerDialog(false);
    setNewBesteller(EMPTY_CONTACT);
  } catch (error) {
    console.error('Fehler beim Anlegen des Bestellers:', error);
    setNewBestellerError(
      error.response?.data?.details || error.response?.data?.error ||
      'Der Besteller konnte nicht angelegt werden.'
    );
  } finally {
    setIsSavingBesteller(false);
  }
};

const calcRowTotal = (row, allRows) => {
  const qty = Number(row?.quantity || 0);
  const ppu = Number(row?.pricePerUnit || 0);

  const type = row?.item?.itemType;

  // Prozent-Versicherung: amount basiert auf Main-Item
  if (type === 'insurance') {
    const main = allRows.find(x => x.id === row.mainItemId);
    if (!main) return 0;

    const mainQty = Number(main?.quantity || 0);
    const mainPPU = Number(main?.pricePerUnit || 0);
    const percentage = qty; // bei insurance ist quantity der %-Wert

    const mbvPPU = (mainPPU * percentage) / 100;
    return mbvPPU * mainQty;
  }

  // insuranceFixed: falls du das so willst → ganz normal qty*ppu
  // (wenn ihr da eine andere Logik habt, sag kurz Bescheid)
  return ppu * qty;
};

// Funktion, um Gesamtsummen zu berechnen und im Backend zu speichern
const saveOfferTotals = async () => {
  const totalNet = offerItems.reduce((sum, row) => sum + calcRowTotal(row, offerItems), 0);
  const vatRate = offer.vatRate ?? 19; // MwSt.-Satz aus dem Angebot oder Standardwert
  const vatAmount = totalNet * (vatRate / 100); // Berechnung der MwSt.
  const totalGross = totalNet + vatAmount; // Brutto = Netto + MwSt.

  try {
    await api.put(`/offers/${offer.id}`, {
      taxTreatment: offer.taxTreatment,
        taxNote: offer.taxNote,
        totalNet,
      vatAmount,
      totalGross,
    });
    console.log('Gesamtsummen erfolgreich gespeichert.');
  } catch (error) {
    console.error('Fehler beim Speichern der Gesamtsummen:', error);
    alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
  }
};

const updateOfferAndSaveTotals = async () => {
  // Zuerst die OfferItems aktualisieren
  const offerItemsUpdateResponse = await api.put(
    `/offers/${offer.id}/offeritems`, 
    offerItems
  );

  // Berechnung der neuen Gesamtsumme
  const totalNet = offerItems.reduce((sum, item) => sum + (item.total || 0), 0);
  const vatRate = offer.vatRate ?? 19;
  const vatAmount = totalNet * (vatRate / 100);
  const totalGross = totalNet + vatAmount;

  // Danach die Offer-Tabelle mit den neuen Gesamtwerten aktualisieren
  try {
    const response = await api.put(`/offers/${offer.id}`, {
      taxTreatment: offer.taxTreatment,
        taxNote: offer.taxNote,
        totalNet,
      vatAmount,
      totalGross,
    });
    console.log('Gesamtsummen erfolgreich gespeichert:', response.data);
  } catch (error) {
    console.error('Fehler beim Speichern der Gesamtsummen:', error);
    alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
  }
};


const handleBackButtonClick = async () => {
  if (await saveOfferTotals() === false) return; // Speichern der Gesamtsummen
  navigate('/offers'); // Zurück zur Angebotsübersicht
};



// --- Sortier-Handling (analog OrderForm) ---
const saveOfferItemDesignPositions = async (items) => {
  try {
    await api.put(
      `/offers/${offer.id}/offeritems/designPositions`,
      items.map(i => ({ id: i.id, designPosition: i.designPosition }))
    );
  } catch (error) {
    console.error('Fehler beim Speichern der Reihenfolge:', error);
  }
};

const moveOfferItemUp = (id) => {
  setOfferItems(prev => {
    let sorted = [...prev].sort((a, b) => (a.designPosition ?? a.position) - (b.designPosition ?? b.position));
    const idx = sorted.findIndex(i => i.id === id);
    if (idx > 0) {
      const temp = sorted[idx - 1].designPosition;
      sorted[idx - 1].designPosition = sorted[idx].designPosition;
      sorted[idx].designPosition = temp;
      saveOfferItemDesignPositions(sorted);
    }
    return [...sorted];
  });
};

const moveOfferItemDown = (id) => {
  setOfferItems(prev => {
    let sorted = [...prev].sort((a, b) => (a.designPosition ?? a.position) - (b.designPosition ?? b.position));
    const idx = sorted.findIndex(i => i.id === id);
    if (idx < sorted.length - 1 && idx !== -1) {
      const temp = sorted[idx + 1].designPosition;
      sorted[idx + 1].designPosition = sorted[idx].designPosition;
      sorted[idx].designPosition = temp;
      saveOfferItemDesignPositions(sorted);
    }
    return [...sorted];
  });
};










  // Angebot speichern
// Angebot speichern
const handleSave = async () => {
  if (!offer.customerId) {
    alert("Bitte wählen Sie einen Kunden aus.");
    return;
  }

  try {
    const offerDate = offer.date || new Date().toISOString();
    const validUntilDate =
      offer.validUntil ||
      new Date(new Date(offerDate).setDate(new Date(offerDate).getDate() + 14)).toISOString();

    // 'draft' -> 'open', damit Nummer vergeben wird
    const finalStatus = offer.status === 'draft' ? 'open' : offer.status;

    const payload = {
      ...offer,
      date: offerDate,
      validUntil: validUntilDate,
      contactId: offer.contactId || null,
      lwOperatorId: offer.lwOperatorId || null,
      allowEmailAcceptance: hasContactMobile(selectedContact) && offer.allowEmailAcceptance !== false,
      isReservation: offer.isReservation,
      status: finalStatus
    };

    let newOfferNumber = null;

    if (mode === "edit") {
      // Wichtig: Response auswerten – viele Backends geben das aktualisierte Objekt zurück
      const res = await api.put(`/offers/${offerId}`, payload);
      const body = res?.data || {};
      // robust extrahieren
      newOfferNumber =
        body.offerNumber ||
        body.data?.offerNumber ||
        offer.offerNumber ||         // Fallback auf lokalen State
        null;

      alert("Angebot erfolgreich aktualisiert!");
    } else {
      const res = await api.post("/offers", payload);
      const body = res?.data || {};
      newOfferNumber = body.offerNumber || body.data?.offerNumber || null;
      alert(
        `Angebot erfolgreich erstellt!${newOfferNumber ? ` Angebotsnummer: ${newOfferNumber}` : ""}`
      );
    }

    // Summen speichern
    await saveOfferTotals();

    if (onSave) onSave();

    // Navigation: nur filtern, wenn eine echte Nummer existiert
    if (newOfferNumber) {
      // Variante A: Übergabe per navigate-state (kein "null" in der URL)
      navigate('/offers', { state: { focusOfferNumber: newOfferNumber } });
    } else {
      // keine Nummer -> einfach zur Liste ohne Filter
      navigate('/offers');
    }
  } catch (error) {
    console.error("Fehler beim Speichern des Angebots:", error);
    alert(error.response?.data?.error || "Fehler beim Speichern des Angebots.");
  }
};



  // Kundenoptionen für React Select
const selectedContactHasMobile = hasContactMobile(selectedContact);

  const customerOptions = filteredCustomers.map((customer) => ({
  value: customer.id,
  label: `${customer.company} (${customer.customerNumber})`,
  isBlocked: !!customer.isBlocked,
  blockedUntil: customer.blockedUntil || null,
  blockReason: customer.blockReason || null,
}));

  if (isLoading) {
    return <div>Daten werden geladen...</div>;
  }

// Hilfsfunktionen für Adressaufbereitung
const buildFullAddress = (street, postalCode, city, country = 'Deutschland') =>
  [street, [postalCode, city].filter(Boolean).join(' '), country]
    .filter(Boolean)
    .join(', ');

const normalizeDestination = (raw, country = 'Deutschland') => {
  if (!raw) return '';
  return /deutschland/i.test(raw) ? raw : `${raw}, ${country}`;
};

// PKW/Google
const buildGoogleMapsUrl = ({ origin, destination }) => {
  const base = 'https://www.google.com/maps/dir/?api=1';
  const params = new URLSearchParams({
    origin,
    destination,
    travelmode: 'driving',
  });
  return `${base}&${params.toString()}`;
};

const openCarRoute = (companySetup, operationLocationRaw) => {
  if (!companySetup || !operationLocationRaw) return;
  const origin = buildFullAddress(
    companySetup.street,
    companySetup.postalCode,
    companySetup.city,
    companySetup.country || 'Deutschland'
  );
  const destination = normalizeDestination(operationLocationRaw);
  window.open(buildGoogleMapsUrl({ origin, destination }), '_blank', 'noopener,noreferrer');
};

// LKW/GraphHopper (kostenloser Deeplink)
const buildGraphHopperTruckUrl = ({ origin, destination, locale = 'de' }) => {
  const base = 'https://graphhopper.com/maps/';
  const params = new URLSearchParams();
  params.set('profile', 'truck');
  params.set('locale', locale);
  params.append('point', origin);
  params.append('point', destination);
  return `${base}?${params.toString()}`;
};

const openTruckRoute = (companySetup, operationLocationRaw) => {
  if (!companySetup || !operationLocationRaw) return;
  const origin = buildFullAddress(
    companySetup.street,
    companySetup.postalCode,
    companySetup.city,
    companySetup.country || 'Deutschland'
  );
  const destination = normalizeDestination(operationLocationRaw);
  window.open(buildGraphHopperTruckUrl({ origin, destination }), '_blank', 'noopener,noreferrer');
};
 

const totalNetCalc = offerItems.reduce((sum, row) => sum + calcRowTotal(row, offerItems), 0);
const vatRate = Number(offer.vatRate ?? 19);
const vatAmountCalc = totalNetCalc * (vatRate / 100);
const totalGrossCalc = totalNetCalc + vatAmountCalc;





  return (
    <div key={offerId} className="offer-form-container">
      <Helmet>
        <title>Angebot bearbeiten</title>
        <meta name="description" content="Angebot bearbeiten" />
      </Helmet>
      <h1>{mode === "edit" ? "Angebot bearbeiten" : "Neues Angebot erstellen"}</h1>

      {mode === "edit" && (
  <div style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#555' }}>
    <div>
      <strong>Erstellt von:</strong>{' '}
      {offer.creator
        ? `${offer.creator.firstName} ${offer.creator.lastName}`
        : 'Unbekannt'}
      {' '}am {formatDateTime(offer.createdAt)}
    </div>
    <div>
      <strong>Zuletzt geändert von:</strong>{' '}
      {offer.updator
        ? `${offer.updator.firstName} ${offer.updator.lastName}`
        : 'Unbekannt'}
      {' '}am {formatDateTime(offer.updatedAt)}
    </div>
  </div>
)}

      <div className="form-row">
        {/* Linke Spalte - Adressblock */}
        <div className="col">
          <label htmlFor="customerId" className="full-width" >
            <div style={{ marginBottom: 4 }}>
    Kunde auswählen:
    <button
      type="button"
      onClick={() => {
        if (!offer.customerId) return;
        navigate(`/customerform/${offer.customerId}`);
      }}
      disabled={!offer.customerId}
      title={offer.customerId ? 'Kunde bearbeiten' : 'Bitte zuerst einen Kunden wählen'}
      style={{
        marginLeft: 6,
        padding: 0,
        border: 'none',
        background: 'transparent',
        cursor: offer.customerId ? 'pointer' : 'not-allowed',
        fontSize: 16,
        lineHeight: 1,
      }}
    >
      ✏️
    </button>
  </div>
            <Select
  id="customerId"
  name="customerId"
  options={customerOptions}
  onInputChange={handleCustomerSearchChange}
  onChange={handleCustomerChange}
  value={customerOptions.find(option => option.value === offer.customerId) || null}
  className="select-box-cst"
  isClearable
  placeholder="Kunde suchen..."
  getOptionValue={(o) => String(o.value)}
  getOptionLabel={(o) => (o.isBlocked ? `🚫 ${o.label}` : o.label)}
  formatOptionLabel={(data) => (
    <span
      title={
        data.isBlocked
          ? (data.blockReason
              ? `Gesperrt${data.blockedUntil ? ` bis ${new Date(data.blockedUntil).toLocaleDateString('de-DE')}` : ''} – Grund: ${data.blockReason}`
              : `Gesperrt${data.blockedUntil ? ` bis ${new Date(data.blockedUntil).toLocaleDateString('de-DE')}` : ''}`
            )
          : ''
      }
    >
      {data.isBlocked ? '🚫 ' : ''}{data.label}
    </span>
  )}
  styles={{
    option: (base, { data, isFocused, isSelected }) => ({
      ...base,
      color: data.isBlocked ? '#b91c1c' : base.color,       // rot bei gesperrt
      fontWeight: data.isBlocked ? 600 : 400,
      backgroundColor: isFocused
        ? (data.isBlocked ? '#fee2e2' : base.backgroundColor)
        : isSelected
          ? base.backgroundColor
          : 'transparent',
    }),
    singleValue: (base, { data }) => ({
      ...base,
      color: data?.isBlocked ? '#b91c1c' : base.color,       // ausgewählter Wert rot
      fontWeight: data?.isBlocked ? 600 : 400,
    }),
  }}
/>

          </label>

          {/* Adressblock - Anzeige der Kundendaten */}
          {selectedCustomer && (
            <div className="customer-details">
              <p><strong>Firma:</strong> {selectedCustomer.company}</p>
              <p><strong>Zusatz:</strong> {selectedCustomer.companyAddon}</p>
              <p><strong>Anrede:</strong> {selectedCustomer.salutation} {selectedCustomer.firstName} {selectedCustomer.lastName}</p>
              <p><strong>Adresse:</strong> {selectedCustomer.street}, {selectedCustomer.postalCode} {selectedCustomer.city}</p>
              <TaxTreatmentFields document={offer} onChange={setOffer} customer={selectedCustomer} />
              
            </div>
          )}

                 
        </div>
        



        {/* Mittlere Spalte - Mietzeitraum */}
        <div className="col">
          
          <div>
      
            {/* Anlieferzeit Feld */}
            <label htmlFor="deliveryTime" className="full-width" >
              Anlieferzeit:
              <input
                type="time"
                id="deliveryTime"
                name="deliveryTime"
                value={offer.deliveryTime || ""}
                onChange={handleChange}
                className="input-box"
              />
            </label>

            {/* Einsatzort (operationLocation) */}
       {/* Einsatzort (operationLocation) */}
            <label htmlFor="operationLocation" className="full-width">
  Einsatzort:
  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
<div ref={opLocWrapRef} style={{ position: 'relative', flex: 1 }}>
  <input
    type="text"
    value={opLocInput}
    onChange={onOpLocChange}
    onFocus={onOpLocFocus}
    onBlur={onOpLocBlur}
    onKeyDown={onOpLocKeyDown}
    placeholder="Straße Hausnr., PLZ Ort"
    style={{
      width: '100%',
      height: 40,
      borderRadius: 4,
      border: '1px solid #ccc',
      padding: '0 10px',
      marginBottom: 10
    }}
  />
  {opLocOpen && (
    <div
      style={{
        position: 'absolute',
        top: 42,
        left: 0,
        right: 0,
        zIndex: 50,
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: 4,
        maxHeight: 260,
        overflowY: 'auto',
        boxShadow: '0 6px 24px rgba(0,0,0,0.08)'
      }}
    >
      {opLocLoading && (
        <div style={{ padding: 8, fontStyle: 'italic', color: '#666' }}>Lade Vorschläge…</div>
      )}
      {!opLocLoading && opLocSuggest.length === 0 && (
        <div style={{ padding: 8, color: '#666' }}>Keine Vorschläge</div>
      )}
      {!opLocLoading && opLocSuggest.map((row, idx) => (
        <div
          key={`${row.label}-${idx}`}
          onMouseDown={() => selectOpLoc(row.label)}
          onMouseEnter={() => setOpLocIndex(idx)}
          style={{
            padding: '8px 10px',
            background: idx === opLocIndex ? '#f3f4f6' : '#fff',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
          title={row.label}
        >
          {row.label}
        </div>
      ))}
    </div>
  )}
</div>


</div>



    {/* NEU: Route-Button (ohne API/Key) */}
    <button
      type="button"
      onClick={() => openCarRoute(companySetup, offer.operationLocation)}
      disabled={!companySetup || !offer.operationLocation}
      title={
        !offer.operationLocation
          ? 'Bitte zuerst den Einsatzort eintragen'
          : (!companySetup ? 'Firmenstandort (CompanySetup) fehlt' : 'Route in Google Maps öffnen')
      }
      style={{
        whiteSpace: 'nowrap',
        padding: '6px 10px',
        borderRadius: 6,
        border: '1px solid #ddd',
        background: (!companySetup || !offer.operationLocation) ? '#eee' : '#4285F4',
        color: (!companySetup || !offer.operationLocation) ? '#888' : '#fff',
        cursor: (!companySetup || !offer.operationLocation) ? 'not-allowed' : 'pointer'
      }}
    >
      PKW
    </button>
    <button
  type="button"
  onClick={() => openTruckRoute(companySetup, offer.operationLocation)}
  disabled={!companySetup || !offer.operationLocation}
   style={{
        whiteSpace: 'nowrap',
        padding: '6px 10px',
        borderRadius: 6,
        border: '1px solid #ddd',
        background: (!companySetup || !offer.operationLocation) ? '#eee' : '#4285F4',
        color: (!companySetup || !offer.operationLocation) ? '#888' : '#fff',
        cursor: (!companySetup || !offer.operationLocation) ? 'not-allowed' : 'pointer'
      }}
  title="LKW-Route (GraphHopper) öffnen"
>
  LKW
</button>

  </div>
</label>


      {/* Ansprechpartner vor Ort */}
<div className="full-width">
  <label htmlFor="lwOperatorId">Ansprechpartner vor Ort:</label>
  <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', flexWrap: 'wrap' }}>
    <select
      id="lwOperatorId"
      name="lwOperatorId"
      value={offer.lwOperatorId}
      onChange={handleLWOperatorChange}
      className="select-box"
      style={{ margin: '10px 0 15px', flex: 1, height: '40px', boxSizing: 'border-box' }}
    >
      <option value="">Bitte Ansprechpartner vor Ort wählen</option>
      {lwOperatorContacts.map((contact) => (
        <option key={contact.id} value={contact.id}>
          {contact.contactFirstName} {contact.contactLastName}
        </option>
      ))}
    </select>
    <button
      type="button"
      onClick={openNewLWOperatorDialog}
      disabled={!offer.customerId}
      title={!offer.customerId ? 'Bitte zuerst einen Kunden auswählen' : 'Neuen LW-Bediener anlegen'}
      style={{
        whiteSpace: 'nowrap', padding: '10px 15px', fontSize: '0.9em',
        height: '40px', boxSizing: 'border-box', marginTop: '10px',
        borderRadius: '5px', border: 'none',
        background: offer.customerId ? '#28a745' : '#bbb', color: '#fff',
        cursor: offer.customerId ? 'pointer' : 'not-allowed',
      }}
    >
      +
    </button>
    {mode === "edit" && (
      <button
        type="button"
        onClick={() => openEditContactDialog(selectedLWOperator)}
        disabled={!selectedLWOperator}
        title={selectedLWOperator
          ? 'Ausgewählten Ansprechpartner bearbeiten'
          : 'Bitte zuerst einen Ansprechpartner auswählen'}
        style={{
          whiteSpace: 'nowrap', padding: '10px 15px', fontSize: '0.9em',
          height: '40px', boxSizing: 'border-box', marginTop: '10px',
          borderRadius: '5px', border: 'none',
          background: selectedLWOperator ? '#007bff' : '#bbb', color: '#fff',
          cursor: selectedLWOperator ? 'pointer' : 'not-allowed',
        }}
      >
        Bearbeiten
      </button>
    )}
  </div>
</div>

{/* Checkboxen unterhalb des Bestellers */}
 <div className="checkbox-group">
      <h3>Als regulärer Miettag zählen:</h3>
      <div className="checkbox-list">
        <label htmlFor="includeSaturday" className="checkbox-item">
          <input
            type="checkbox"
            id="includeSaturday"
            name="includeSaturday"
            checked={tempIncludeSaturday}
            onChange={e =>
              handleGlobalCheckboxChange("includeSaturday", e.target.checked)
            }
            disabled={!isEditing}
          />
          Samstag
        </label>

        <label htmlFor="includeSunday" className="checkbox-item">
          <input
            type="checkbox"
            id="includeSunday"
            name="includeSunday"
            checked={tempIncludeSunday}
            onChange={e =>
              handleGlobalCheckboxChange("includeSunday", e.target.checked)
            }
            disabled={!isEditing}
          />
          Sonntag
        </label>

        <label htmlFor="includeHolidays" className="checkbox-item">
          <input
            type="checkbox"
            id="includeHolidays"
            name="includeHolidays"
            checked={tempIncludeHolidays}
            onChange={e =>
              handleGlobalCheckboxChange("includeHolidays", e.target.checked)
            }
            disabled={!isEditing}
          />
          Feiertage
        </label>

        <label htmlFor="isReservation" className="checkbox-item">
          <input
            type="checkbox"
            id="isReservation"
            name="isReservation"
            checked={offer.isReservation}
            onChange={e =>
              setOffer({ ...offer, isReservation: e.target.checked })
            }
          
          />
          Res. Kalender
        </label>
      </div>
    </div>



 {/* Angebotsnotiz */}
 {mode === 'edit' && (
   <label htmlFor="offerNoteTextBlock" className="full-width" style={{ marginTop: '15px' }}>
     Textbaustein für Angebotsnotiz:
     <select
       id="offerNoteTextBlock"
       value={selectedOfferNoteTextBlockId}
       onChange={handleOfferNoteTextBlockChange}
       disabled={offerNoteTextBlocksLoading || offerNoteTextBlocks.length === 0}
       style={{ width: '100%', margin: '8px 0 10px 0', padding: '8px', boxSizing: 'border-box' }}
     >
       <option value="">
         {offerNoteTextBlocksLoading
           ? 'Textbausteine werden geladen...'
           : offerNoteTextBlocks.length === 0
             ? 'Keine aktiven Textbausteine vorhanden'
             : 'Textbaustein auswählen...'}
       </option>
       {offerNoteTextBlocks.map(textBlock => (
         <option key={textBlock.id} value={textBlock.id}>
           {textBlock.name}
         </option>
       ))}
     </select>
   </label>
 )}

 <label htmlFor="notes" className="full-width" style={{ marginTop: '5px' }}><textarea
    id="notes"
    name="notes"
    value={offer.notes}
    onChange={handleChange}
    className="textarea-notes"
    rows="3"
    style={{ width: '100%', marginTop: '10px' }} // Breite kann hier angepasst werden
    placeholder="Angebotsnotiz"
  />
</label>
{/* interne Angebotsnotiz */}
 <label htmlFor="internalNotes" className="full-width" style={{ marginTop: '5px' }}><textarea
    id="internalNotes"
    name="internalNotes"
    value={offer.internalNotes}
    onChange={handleChange}
    className="textarea-internalNotes"
    rows="3"
    style={{ width: '100%', marginTop: '10px' }} // Breite kann hier angepasst werden
    placeholder="interne Angebotsnotiz"
  />
</label>
</div> {/* Ende <div className="col"> für die mittlere Spalte */}
    <div className="col">



{/* Angebotspositionen */}
<div className="table-breakout" style={{ marginTop: '40px' }}>
  <h3>Angebotspositionen</h3>

  <table className="order-positions-table" >
 
    <thead>
      <tr>
        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Position</th>
        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Artikel</th>
        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Beschreibung</th>
        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Einheit</th>
        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Menge</th>
        <th style={{ border: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>E-Preis</th>
        <th style={{ border: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>Gesamt</th>
        <th>Von</th>
        <th>Bis</th>
        <th>Zeit Von</th>
        <th>Zeit Bis</th>
        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Aktionen</th>
      </tr>
    </thead>
    <tbody>
    {[...offerItems]
  .sort((a, b) => Number(a.designPosition ?? a.position ?? 0) - Number(b.designPosition ?? b.position ?? 0))
  .map((position, index) => {
    const isRental = position.item?.itemType === 'rental';
    const isInsuranceItem = position.item?.itemType === 'insurance';
    const isInsuranceFixedItem = position.item?.itemType === 'insuranceFixed';
    const editingThisRow = editingRowId === position.id;
    const unitName =
      position.item?.machineType?.typePricings?.[0]?.unit?.name ||
      position.item?.transportPricings?.[0]?.unit?.name ||
      (isInsuranceItem ? 'Prozent' : 'n.a.');

    let pricePerUnit = 0;
    let total = 0;


    // MBV-Berechnung
    if (isInsuranceItem) {
      const mainItem = offerItems.find(
        (item) => item.id === position.mainItemId
      );

      if (mainItem) {
        const insurancePercentage = position.quantity;
        const mbvPricePerUnit = (mainItem.pricePerUnit * insurancePercentage) / 100;
        const mbvTotal = mbvPricePerUnit * mainItem.quantity;

        pricePerUnit = mbvPricePerUnit;
        total = mbvTotal;
      }
    } else if (position.pricePerUnit && position.quantity) {
      pricePerUnit = position.pricePerUnit;
      total = (position.quantity * position.pricePerUnit);
    }

    const isLinkedItem = !!position.mainItemId;

    // Formatierung des Einzelpreises
    const formattedPricePerUnit = (typeof pricePerUnit === 'number' && !isNaN(pricePerUnit))
    ? pricePerUnit.toFixed(2).replace('.', ',') + ' €'
    : '0,00 €';

  // Formatierung des Gesamtpreises
  const formattedTotal = (typeof total === 'number' && !isNaN(total))
    ? total.toFixed(2).replace('.', ',') + ' €'
    : '0,00 €';

    return (
      <tr key={position.id ?? position.tempId} style={isLinkedItem ? { paddingLeft: '20px' } : {}}>

        {/* Positionsnummer */}
        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{index + 1}</td>

        {/* Artikelname */}
        <td style={{ border: '1px solid #ddd', padding: '8px', width: '25ch', minWidth: '25ch', maxWidth: '25ch' }}>
        {editingThisRow && !isInsuranceItem ? (
            <input
              type="text"
              value={position.item?.name || ''}
              style={{ width: '25ch', minWidth: '25ch', maxWidth: '25ch' }}
              onChange={(e) =>
                setOfferItems((prev) =>
                  prev.map((item) =>
                    item.id === position.id
                      ? { ...item, item: { ...item.item, name: e.target.value } }
                      : item
                  )
                )
              }
            />
          ) : (
            <span
              style={{
                display: 'inline-block',
                width: '25ch',
                minWidth: '25ch',
                maxWidth: '25ch',
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-all',
              }}
            >
              {position.item?.name}
            </span>
          )}
        </td>

        {/* Beschreibung */}
<td style={{ border: '1px solid #ddd', padding: '8px' }}>
  {editingThisRow && !isInsuranceItem ? (
    <textarea
      value={position.description ?? position.item?.description ?? ''}
      wrap="soft"
      style={{ maxWidth: '320px' }}
      onChange={(e) =>
        setOfferItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { ...item, description: e.target.value }
              : item
          )
        )
      }
    />
  ) : (
    position.description || position.item?.description || 'Keine Beschreibung verfügbar'
  )}
</td>

{/* Einheit */}
<td style={{ border: '1px solid #ddd', padding: '8px' }}>
{editingThisRow && !isInsuranceItem ? (
    <>

      <select
        value={position.unitId != null ? position.unitId.toString() : ''} // Zeige die aktuelle Einheit, nicht "Einheit wählen"
        style={{ width: '100%', minWidth: '150px', margin: '0 0 10px 0' }}
        onChange={(e) => {
          const newUnitId = e.target.value ? parseInt(e.target.value, 10) : null;

          // Setze die neue Einheit im Zustand, wenn die Einheit geändert wird
          setOfferItems((prev) =>
            prev.map((item) =>
              item.id === position.id
                ? { ...item, unitId: newUnitId } // Aktualisiere die Einheit für diese Position
                : item
            )
          );

          // Speichern der geänderten Einheit im Backend
       
        }}
      >
        <option value="">Einheit wählen</option>
        {position.item?.machineType?.typePricings
          ?.map((pricing) => pricing.unit) // Alle verfügbaren Einheiten
          ?.filter((unit, index, self) => unit && self.findIndex((u) => u.id === unit.id) === index) // Verhindere doppelte Einheiten
          .map((unit) => (
            <option key={unit.id} value={unit.id.toString()}>
              {unit.name}
            </option>
          ))}
      </select>
    </>
  ) : (
    position.unit?.name || '' // Zeige die Einheit im normalen Modus
  )}
</td>

        {/* Menge */}
        <td style={{ border: '1px solid #ddd', padding: '8px' }}>
        {editingThisRow && !isInsuranceItem && !isInsuranceFixedItem ? (
            <input
              type="number"
              value={position.quantity || ''}
              onChange={(e) =>
                setOfferItems((prev) =>
                  prev.map((item) =>
                    item.id === position.id
                      ? { ...item, quantity: parseFloat(e.target.value) || 0,
                        manualPriceActive: false // Flag zurücksetzen, damit automatische Preisberechnung wieder greift
                       }
                      : item
                  )
                )
              }
              min="0"
            />
          ) : isInsuranceItem ? (
    // Prozent-Versicherung
    `${position.quantity}%`
  ) : isInsuranceFixedItem ? (
    // Fixed-Insurance: nur Zahl anzeigen (read-only)
    position.quantity
  ) : (
    // alle anderen Typen
    position.quantity
  )}
                      </td>

        {/* Einzelpreis */}
        <td style={{ border: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>
        {editingThisRow && !isInsuranceItem ? (
            <input
              type="number"
              value={position.pricePerUnit || ''}
              style={{ minWidth: '12ch' }}
              onChange={(e) =>
                setOfferItems((prev) =>
                  prev.map((item) =>
                    item.id === position.id
                      ? { ...item, pricePerUnit: parseFloat(e.target.value) || 0,
                        manualPriceActive: true // Flag setzen, wenn der Preis manuell geändert wurde 
                       }
                      : item
                  )
                )
              }
              min="0"
              step="0.01"
            />
          ) : (
              // Formatierung des Einzelpreises mit Komma und Euro-Symbol
              (typeof pricePerUnit === 'number' && !isNaN(pricePerUnit))
                ? pricePerUnit.toFixed(2).replace('.', ',') + ' €'
                : '0,00 €'
          )}
        </td>

        {/* Gesamtpreis */}
        <td style={{ border: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>
            {typeof total === 'number' && !isNaN(total)
              ? total.toFixed(2).replace('.', ',') + ' €'
              : '0,00 €'}
          </td>
          {isRental && (
          <>
             {/* Mietzeitraum Von */}
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
            {editingThisRow && !isInsuranceItem ? (
                <input
                  type="date"
                  value={position.rentalPeriodFrom || ''}
                  onChange={(e) =>
                    setOfferItems((prev) =>
                      prev.map((item) =>
                        item.id === position.id
                          ? { ...item, rentalPeriodFrom: e.target.value }
                          : item
                      )
                    )
                  }
                />
              ) : (
                position.rentalPeriodFrom ? formatDate(position.rentalPeriodFrom) : '-'
              )}
            </td>

            {/* Mietzeitraum Bis */}
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {editingThisRow && !isInsuranceItem ? (
                <input
                  type="date"
                  value={position.rentalPeriodTo || ''}
                  readOnly
                  style={{
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                  }}
                />
              ) : (
                position.rentalPeriodTo ? formatDate(position.rentalPeriodTo) : '-'
              )}
            </td>

            {/* Mietzeit Von */}
<td style={{ border: '1px solid #ddd', padding: '8px' }}>
{editingThisRow && !isInsuranceItem ? (
    <input
      type="time"
      value={position.rentalTimeFrom || ''}
      onChange={(e) => {
        console.log('Änderung in rentalTimeFrom:', e.target.value); // Debugging
        setOfferItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { ...item, rentalTimeFrom: e.target.value }
              : item
          )
        );
      }}
    />
  ) : (
    position.rentalTimeFrom || '-'
  )}
</td>

            {/* Mietzeit Bis */}
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
            {editingThisRow && !isInsuranceItem ? (
                <input
                  type="time"
                  value={position.rentalTimeTo || ''}
                  onChange={(e) =>
                    setOfferItems((prev) =>
                      prev.map((item) =>
                        item.id === position.id
                          ? { ...item, rentalTimeTo: e.target.value }
                          : item
                      )
                    )
                  }
                />
              ) : (
                position.rentalTimeTo || '-'
              )}
            </td>
          </>
        )}

        {!isRental && (
          <td colSpan={4} style={{ border: '1px solid #ddd', padding: '8px' }}></td>
        )}
       

       {/* Aktionen */}
       <td style={{ border: '1px solid #ddd', padding: '8px' }}>
       {editingThisRow ? (
            <div style={{ display: 'flex' }}>
              <button
                type="button"
                onClick={() => saveEditedRow(position.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#28a745',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                }}
              >
                Speichern
              </button>
              <button
                type="button"
                onClick={handleCancelEdit}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#6c757d',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  marginLeft: '10px',
                }}
              >
                Abbrechen
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex' }}>
              {/* Verstecke/Deaktiviere den Bearbeiten-Button, falls insurance */}
            { !isInsuranceItem
   && position.item?.itemType !== 'insuranceFixed' && (
              <button
                type="button"
                onClick={() => handleEditClick(position.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  marginRight: '10px',
                }}
              >
                Bearbeiten
              </button>
               )}
              <button
                type="button"
                onClick={() => removeOfferItem(position.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#dc3545',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                }}
              >
                Löschen
              </button>
              <div style={{ display: 'inline-flex', gap: '4px', marginLeft: '6px' }}>
    <button
      type="button"
      title="Nach oben"
      onClick={() => moveOfferItemUp(position.id)}
      disabled={index === 0}
      style={{ marginRight: 6, padding: '2px 6px', color: '#fff', background: '#aaaaaa' }}
    >▲</button>
    <button
      type="button"
      title="Nach unten"
      onClick={() => moveOfferItemDown(position.id)}
      disabled={index === offerItems.length - 1}
      style={{ padding: '2px 6px', color: '#fff', background: '#aaaaaa' }}
    >▼</button>
  </div>
            </div>
          )}
        </td>
      </tr>
    );
  })}
</tbody>


</table>
 
</div>

{/* Gesamtsummen-Tabelle */}
<div style={{ marginTop: '20px', width: '100%', maxWidth: '800px' }}>
  <h3>Zusammenfassung</h3>
  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
    <tbody>
      {/* Gesamt Netto */}
      <tr>
        <td style={{ border: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>Gesamt Netto</td>
        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
          {/* Berechnung von totalNet */}
          {totalNetCalc.toFixed(2).replace('.', ',') + ' €'}
        </td>
      </tr>

      {/* MwSt. */}
      <tr>
        <td style={{ border: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>zzgl. MwSt. ({offer.vatRate ?? 19}%)</td>
        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
          {/* Berechnung der MwSt. */}
         {vatAmountCalc.toFixed(2).replace('.', ',') + ' €'}
        </td>
      </tr>

      {/* Brutto */}
      <tr>
        <td style={{ border: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>Rechnungsbetrag</td>
        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
          {/* Berechnung des Bruttobetrags */}
          {totalGrossCalc.toFixed(2).replace('.', ',') + ' €'}
        </td>
      </tr>
    </tbody>
  </table>
</div>












{/* Neue Angebotsposition hinzufügen */}
<div className="offer-item-addition" style={{ marginTop: '20px' }}>
  <h3>Neue Angebotsposition hinzufügen</h3>
  <div className="form-group" style={{ marginBottom: '15px' }}>
    <label htmlFor="quantity">Menge:</label>
    <input
      type="number"
      id="quantity"
      value={selectedQuantity}
      onChange={(e) => setSelectedQuantity(e.target.value)}
      min="1"
      style={{ display: 'block', marginTop: '5px', padding: '8px', width: '100%' }}
    />
  </div>
  <div className="form-group" style={{ marginBottom: '15px' }}>
    <label htmlFor="itemId"></label>
    <Select
      id="itemId"
      options={itemOptions}
      value={
        items
          .map((item) => ({ value: item.id, label: formatItemOptionLabel(item) }))
          .find((option) => option.value === selectedItemId) || null
      } // Aktuell ausgewählt
      onChange={(selectedOption) => setSelectedItemId(selectedOption ? selectedOption.value : null)} // Auswahl speichern
      onInputChange={(inputValue, { action }) => {
                  if (action === 'input-change') {
                    // nichts zurückgeben!
                    void fetchFilteredItems(inputValue);
                  }
                }} // Filterfunktion
      placeholder="Artikel suchen..."
      isClearable
      filterOption={safeFilterOption} 
      styles={{
        control: (base) => ({
          ...base,
          marginTop: '5px',
          width: '100%',
        }),
      }}
    />
  </div>
  
  <button type="button" onClick={addOfferItem} style={{ padding: '10px 20px', cursor: 'pointer' }}>
    Angebotsposition hinzufügen
  </button>
</div>





          </div>
        </div>

        {/* Rechte Spalte - Angebotsnummer und Besteller */}
        <div className="col">

          
          {/* Angebotsnummer, Angebotsdatum und Angebotsgültigkeit anzeigen*/}
          {offer.offerNumber && (
            <div>
              <p><strong>Angebotsnummer:</strong> {offer.offerNumber}</p>
              <p><strong>Angebotsdatum:</strong> {offer.date ? formatDate(offer.date) : formatDate(new Date())}</p>
              <p><strong>Angebot gültig bis:</strong> {formatDate(offer.validUntil)}</p>
            </div>
          )}

          <div className="full-width">
            <label htmlFor="contactId">Besteller:</label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', justifyContent: 'center', flexWrap: 'wrap' }}>
              <select
                id="contactId"
                name="contactId"
                value={offer.contactId}
                onChange={handleContactChange}
                className="select-box-bst"
                style={{
                  flex: '0 1 304px', minWidth: 0, maxWidth: '80%',
                  margin: '10px 0 15px'
                }}
              >
                <option value="">Besteller wählen</option>
                {customerContacts.map((contact) => (
                  <option key={contact.id} value={contact.id}>
                    {contact.contactFirstName} {contact.contactLastName}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={openNewBestellerDialog}
                disabled={!offer.customerId}
                title={!offer.customerId ? 'Bitte zuerst einen Kunden auswählen' : 'Neuen Besteller anlegen'}
                style={{
                  whiteSpace: 'nowrap', padding: '10px 15px', fontSize: '0.9em',
                  borderRadius: '5px', border: 'none', marginTop: '10px',
                  background: offer.customerId ? '#28a745' : '#bbb', color: '#fff',
                  cursor: offer.customerId ? 'pointer' : 'not-allowed',
                }}
              >
                +
              </button>
              {mode === "edit" && (
                <button
                  type="button"
                  onClick={() => openEditContactDialog(selectedContact)}
                  disabled={!selectedContact}
                  title={selectedContact
                    ? 'Ausgewählten Besteller bearbeiten'
                    : 'Bitte zuerst einen Besteller auswählen'}
                  style={{
                    whiteSpace: 'nowrap', padding: '10px 15px', fontSize: '0.9em',
                    borderRadius: '5px', border: 'none', marginTop: '10px',
                    background: selectedContact ? '#007bff' : '#bbb', color: '#fff',
                    cursor: selectedContact ? 'pointer' : 'not-allowed',
                  }}
                >
                  Bearbeiten
                </button>
              )}
            </div>
            {customerContacts.length === 0 && (
              <small style={{ color: '#666' }}>Für diesen Kunden ist noch kein Besteller hinterlegt.</small>
            )}
          </div>

          {selectedContact && (
            <div className="contact-details">
              <p><strong>Name:</strong> {selectedContact.contactFirstName} {selectedContact.contactLastName}</p>
              <p><strong>Mobil:</strong> {selectedContact.contactMobile}</p>
              <p><strong>Email:</strong> {selectedContact.contactEmail}</p>
              <div className="offer-email-options">
                <input
                  id="offerIncludeLaddersInEmail"
                  type="checkbox"
                  checked={!!offer.includeLaddersInEmail}
                  onChange={(e) =>
                    setOffer((prev) => ({ ...prev, includeLaddersInEmail: e.target.checked }))
                  }
                />
                <label htmlFor="offerIncludeLaddersInEmail">
                  Preisstaffeln in E-Mail
                </label>
                <input
                  id="offerAllowEmailAcceptance"
                  type="checkbox"
                  checked={selectedContactHasMobile && offer.allowEmailAcceptance !== false}
                  disabled={!selectedContactHasMobile}
                  title={!selectedContactHasMobile ? 'Beim Besteller ist keine Mobilnummer hinterlegt.' : undefined}
                  onChange={(e) =>
                    setOffer((prev) => ({ ...prev, allowEmailAcceptance: e.target.checked }))
                  }
                />
                <label htmlFor="offerAllowEmailAcceptance">
                  Accept per E-Mail
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="actions">
 {/*     <button type="button" onClick={handleBackButtonClick}style={{ marginRight: '10px', padding: '10px 20px', cursor: 'pointer' }}>
          Zurück
        </button>     */}
        <button type="button" onClick={handleSave} style={{ padding: '10px 20px', cursor: 'pointer' }}>
          {mode === "edit" ? "Speichern" : "Erstellen"}
        </button>
      </div>

      <ContactDialog
        open={showNewBestellerDialog}
        title="Besteller anlegen"
        roleLabel="Besteller"
        customerName={selectedCustomer?.company}
        contact={newBesteller}
        error={newBestellerError}
        isSaving={isSavingBesteller}
        onChange={handleNewBestellerChange}
        onClose={closeNewBestellerDialog}
        onSave={saveNewBesteller}
      />

      <ContactDialog
        open={showNewLWOperatorDialog}
        title="Ansprechpartner vor Ort anlegen"
        roleLabel="LW-Bediener"
        customerName={selectedCustomer?.company}
        contact={newLWOperator}
        error={newLWOperatorError}
        isSaving={isSavingLWOperator}
        onChange={handleNewLWOperatorChange}
        onClose={closeNewLWOperatorDialog}
        onSave={saveNewLWOperator}
      />

      <ContactDialog
        open={Boolean(contactToEdit)}
        title={String(contactToEdit?.contactFunction || '').toLowerCase() === 'besteller'
          ? 'Besteller bearbeiten'
          : 'Ansprechpartner vor Ort bearbeiten'}
        description={`Die Änderung wird zentral beim Kontakt von ${selectedCustomer?.company || 'diesem Kunden'} gespeichert und ist dadurch auch in anderen Vorgängen sichtbar.`}
        customerName={selectedCustomer?.company}
        contact={contactToEdit || EMPTY_CONTACT}
        error={editContactError}
        isSaving={isSavingEditedContact}
        onChange={handleEditContactChange}
        onClose={closeEditContactDialog}
        onSave={saveEditedContact}
        saveLabel="Änderungen speichern"
        saveColor="#007bff"
      />
    </div>
  );
};

export default OfferForm;
